!(function (e, r) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = r())
    : 'function' == typeof define && define.amd
      ? define([], r)
      : 'object' == typeof exports
        ? (exports.ConnectiveWrapperLegacyInterop = r())
        : (e.ConnectiveWrapperLegacyInterop = r());
})(window, function () {
  return (function (e) {
    var r = {};
    function n(t) {
      if (r[t]) return r[t].exports;
      var i = (r[t] = { i: t, l: !1, exports: {} });
      return (e[t].call(i.exports, i, i.exports, n), (i.l = !0), i.exports);
    }
    return (
      (n.m = e),
      (n.c = r),
      (n.d = function (e, r, t) {
        n.o(e, r) || Object.defineProperty(e, r, { enumerable: !0, get: t });
      }),
      (n.r = function (e) {
        ('undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(e, '__esModule', { value: !0 }));
      }),
      (n.t = function (e, r) {
        if ((1 & r && (e = n(e)), 8 & r)) return e;
        if (4 & r && 'object' == typeof e && e && e.__esModule) return e;
        var t = Object.create(null);
        if (
          (n.r(t),
          Object.defineProperty(t, 'default', { enumerable: !0, value: e }),
          2 & r && 'string' != typeof e)
        )
          for (var i in e)
            n.d(
              t,
              i,
              function (r) {
                return e[r];
              }.bind(null, i),
            );
        return t;
      }),
      (n.n = function (e) {
        var r =
          e && e.__esModule
            ? function () {
                return e.default;
              }
            : function () {
                return e;
              };
        return (n.d(r, 'a', r), r);
      }),
      (n.o = function (e, r) {
        return Object.prototype.hasOwnProperty.call(e, r);
      }),
      (n.p = ''),
      n((n.s = 3))
    );
  })([
    /* FEDNOT edit : comment lines below to avoid "ReferenceError: ConnectiveWrapper is not defined" */
    /* function (e, r) {
        e.exports = ConnectiveWrapper;
      }, */
    function (e, r, n) {
      'use strict';
      Object.defineProperty(r, '__esModule', { value: !0 });
      var t = n(0),
        i = n(0),
        o = n(2),
        a = n(6),
        s = n(7),
        c = n(0),
        u = n(0),
        d = (window.connective = window.connective || {}),
        l = (function () {
          function e(e) {
            (void 0 === e && (e = {}),
              (this.pollingForReader = !1),
              (this.pollingForReaders = !1),
              (this.shouldStopPollingForReader = !1),
              (this.shouldStopPollingForReaders = !1),
              (this.pluginOptions = e),
              (this.newPluginApi = t.PluginApiFactory.getInstance().createPluginApi(e)));
          }
          return (
            (e.prototype.initialize = function () {
              return Promise.resolve();
            }),
            (e.prototype.checkIfPluginIsInstalled = function () {
              return this.newPluginApi.initialize(this.pluginOptions).catch(function (e) {
                return e instanceof i.Exceptions.SoftwareRequiredException
                  ? Promise.reject(
                      new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_INSTALLED, {
                        downloadUrl: e.downloadUrl,
                      }),
                    )
                  : e instanceof i.Exceptions.FatalException
                    ? Promise.reject(
                        new d.plugin.PluginError(d.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                      )
                    : void 0;
              });
            }),
            (e.prototype.activate = function (e) {
              var r = this;
              return (
                (this.pluginOptions.activationToken = e),
                new Promise(function (e, r) {
                  return setTimeout(e, 500);
                })
                  .then(function () {
                    return r.newPluginApi.initialize(r.pluginOptions);
                  })
                  .catch(function (e) {
                    return e instanceof i.Exceptions.SoftwareRequiredException
                      ? Promise.reject(
                          new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_INSTALLED, {
                            downloadUrl: e.downloadUrl,
                          }),
                        )
                      : e instanceof i.Exceptions.ActivationRequiredException
                        ? Promise.reject(
                            new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_ACTIVATED, {
                              e: e,
                            }),
                          )
                        : Promise.reject(
                            new d.plugin.PluginError(d.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                          );
                  })
              );
            }),
            (e.prototype.getReaders = function (e) {
              var r = this;
              return (
                void 0 === e && (e = []),
                null == this.pluginOptions.activationToken ||
                0 == this.pluginOptions.activationToken.length
                  ? Promise.reject(new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_ACTIVATED))
                  : this.newPluginApi.getCardReaders().then(function (n) {
                      var t = [];
                      return (
                        e.length > 0
                          ? ((-1 == e.indexOf(s.LegacyCardType.eID) &&
                              -1 == e.indexOf(s.LegacyCardType.BeID)) ||
                              n.forEach(function (e) {
                                e.containsCard() &&
                                  e.getCardInfo().matches(c.BeID.cardInfo) &&
                                  t.push(e);
                              }),
                            -1 != e.indexOf(s.LegacyCardType.BeLawyer) &&
                              n.forEach(function (e) {
                                e.containsCard() &&
                                  e.getCardInfo().matches(u.BeLawyer.cardInfo) &&
                                  t.push(e);
                              }))
                          : (t = n),
                        0 === t.length
                          ? Promise.reject(
                              new d.plugin.PluginError(d.plugin.Errors.NO_CARD_READERS_FOUND),
                            )
                          : t.map(function (e) {
                              return new o.ReaderInterop(e, r.newPluginApi);
                            })
                      );
                    })
              );
            }),
            (e.prototype.getFirstAvailableReader = function () {
              return null == this.pluginOptions.activationToken ||
                0 == this.pluginOptions.activationToken.length
                ? Promise.reject(new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_ACTIVATED))
                : this.getReaders().then(function (e) {
                    return e.length >= 1
                      ? e[0]
                      : Promise.reject(
                          new d.plugin.PluginError(d.plugin.Errors.NO_AVAILABLE_CARD_READER_FOUND),
                        );
                  });
            }),
            (e.prototype.getSignerPads = function () {
              var e = this;
              return null == this.pluginOptions.activationToken ||
                0 == this.pluginOptions.activationToken.length
                ? Promise.reject(new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_ACTIVATED))
                : this.newPluginApi.getSignerPads().then(function (r) {
                    return 0 === r.length
                      ? Promise.reject(
                          new d.plugin.PluginError(d.plugin.Errors.NO_SIGNER_PADS_FOUND),
                        )
                      : r.map(function (r) {
                          return new a.SignerPadInterop(r, e.newPluginApi);
                        });
                  });
            }),
            (e.prototype.isPollingForReaders = function () {
              return this.pollingForReaders;
            }),
            (e.prototype.pollForReader = function (e, r) {
              var n = this;
              if (
                null == this.pluginOptions.activationToken ||
                0 == this.pluginOptions.activationToken.length
              )
                return Promise.reject(
                  new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_ACTIVATED),
                );
              if (this.isPollingForReader()) return Promise.reject();
              ((this.pollingForReader = !0), (this.shouldStopPollingForReader = !1));
              var t = 0;
              return (function i() {
                return n.getReaders().then(function (o) {
                  return null == o || 0 == o.length
                    ? n.shouldStopPollingForReader || (r > 0 && t + 1 >= r)
                      ? ((n.pollingForReader = !1),
                        (n.shouldStopPollingForReader = !1),
                        Promise.reject(
                          new d.plugin.PluginError(d.plugin.Errors.NO_AVAILABLE_CARD_READER_FOUND),
                        ))
                      : ((t += 1),
                        new Promise(function (r, n) {
                          return setTimeout(r, e);
                        }).then(function () {
                          return i();
                        }))
                    : ((n.pollingForReader = !1), (n.shouldStopPollingForReader = !1), o[0]);
                });
              })();
            }),
            (e.prototype.stopPollingForReader = function () {
              this.shouldStopPollingForReader = !0;
            }),
            (e.prototype.isPollingForReader = function () {
              return this.pollingForReader;
            }),
            (e.prototype.pollForReaders = function (e, r) {
              var n = this;
              if (
                (void 0 === e && (e = 1e3),
                void 0 === r && (r = []),
                null == this.pluginOptions.activationToken ||
                  0 == this.pluginOptions.activationToken.length)
              )
                return Promise.reject(
                  new d.plugin.PluginError(d.plugin.Errors.PLUGIN_NOT_ACTIVATED),
                );
              if (this.isPollingForReaders()) return Promise.reject();
              ((this.pollingForReaders = !0), (this.shouldStopPollingForReaders = !1));
              return (function t() {
                return n
                  .getReaders(r)
                  .then(function (r) {
                    return null == r || 0 == r.length
                      ? n.shouldStopPollingForReaders
                        ? ((n.pollingForReaders = !1),
                          (n.shouldStopPollingForReaders = !1),
                          Promise.reject(
                            new d.plugin.PluginError(
                              d.plugin.Errors.NO_AVAILABLE_CARD_READER_FOUND,
                            ),
                          ))
                        : new Promise(function (r, n) {
                            return setTimeout(r, e);
                          }).then(function () {
                            return t();
                          })
                      : ((n.pollingForReaders = !1), (n.shouldStopPollingForReaders = !1), r);
                  })
                  .catch(function (r) {
                    return r instanceof d.plugin.PluginError &&
                      r.code === d.plugin.Errors.NO_CARD_READERS_FOUND
                      ? n.shouldStopPollingForReaders
                        ? ((n.shouldStopPollingForReaders = !1),
                          (n.pollingForReaders = !1),
                          Promise.reject(
                            new d.plugin.PluginError(
                              d.plugin.Errors.NO_AVAILABLE_CARD_READER_FOUND,
                            ),
                          ))
                        : new Promise(function (r, n) {
                            return setTimeout(r, e);
                          }).then(function () {
                            return t();
                          })
                      : Promise.reject(r);
                  });
              })();
            }),
            (e.prototype.stopPollingForReaders = function () {
              this.shouldStopPollingForReaders = !0;
            }),
            (e.prototype.isInstalledPluginVersionSupported = function (e) {
              return !0;
            }),
            (e.prototype.openBrowser = function (e) {
              window.location = e;
            }),
            e
          );
        })();
      r.PluginApiInterop = l;
    },
    function (e, r, n) {
      'use strict';
      Object.defineProperty(r, '__esModule', { value: !0 });
      var t = n(0),
        i = n(0),
        o = n(0),
        a = n(0),
        s = n(5),
        c = (window.connective = window.connective || {}),
        u = {
          AUTHENTICATION: '3F00DF005038',
          SIGNER: '3F00DF005039',
          CA: '3F00DF00503A',
          ROOT: '3F00DF00503B',
          RN: '3F00DF00503C',
        },
        d = {
          PERSONAL: '3F00DF014031',
          PERSONAL_SIGNATURE: '3F00DF014032',
          ADDRESS: '3F00DF014033',
          ADDRESS_SIGNATURE: '3F00DF014034',
          PHOTO: '3F00DF014035',
        },
        l = '501543042F01',
        p = '50154304C001',
        g = '50154304503A',
        f = '50154304503B',
        E = '501544444403',
        R = '501544444404',
        h = '50155032',
        P = (function () {
          function e(e, r) {
            ((this.newReader = e), (this.newApi = r), (this.INFO_IDS = d), (this.CERT_IDS = u));
          }
          return (
            (e.prototype.isBluetoothReader = function () {
              return !1;
            }),
            (e.prototype.connect = function () {
              return Promise.resolve();
            }),
            (e.prototype.isPinPadReader = function () {
              return Promise.resolve(this.newReader.isPinPad());
            }),
            (e.prototype.validatePin = function (e, r) {
              var n = this;
              return this.newApi
                .getCardHandler(this.newReader)
                .verifyPin(this.newReader)
                .then(function (e) {
                  return ((n.lastPinToken = e), e);
                })
                .catch(function (e) {
                  return e instanceof a.Exceptions.InvalidPinException
                    ? 0 === e.remainingTries || e.pinBlocked
                      ? Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.LOCKED_CARD, {
                            remainingAttempts: 0,
                          }),
                        )
                      : Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.INVALID_PIN, {
                            remainingAttempts: e.remainingTries,
                          }),
                        )
                    : e instanceof a.Exceptions.OperationCanceledException
                      ? Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.PIN_ENTRY_CANCEL_OR_TIMEOUT, {
                            e: e,
                          }),
                        )
                      : Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                        );
                });
            }),
            (e.prototype.readFile = function (e) {
              var r = this.newApi.getCardHandler(this.newReader);
              switch (e) {
                case u.AUTHENTICATION:
                  return this.readAuthenticationCertificate();
                case u.SIGNER:
                  return this.readSignerCertificate();
                case u.RN:
                  return r
                    .readCertificates(this.newReader, i.BeID.CertificateKindHints.RN)
                    .then(function (e) {
                      return e.length > 0 ? e[0] : null;
                    })
                    .then(function (e) {
                      return null != e
                        ? t.Encoding.encodeAsHexString(t.Encoding.decodeBase64String(e))
                        : null;
                    });
                case u.CA:
                  return this.readCaCertificate();
                case u.ROOT:
                  return this.readRootCertificate();
                case d.PERSONAL:
                  return r
                    .readData(this.newReader, i.BeID.DataKindHints.RawPersonalInformation)
                    .then(function (e) {
                      return t.Encoding.encodeAsHexString(
                        t.Encoding.decodeBase64String(
                          e[i.BeID.DataKindHints.RawPersonalInformation],
                        ),
                      );
                    });
                case d.PERSONAL_SIGNATURE:
                  return r
                    .readData(this.newReader, i.BeID.DataKindHints.PersonalInformationSignature)
                    .then(function (e) {
                      return t.Encoding.encodeAsHexString(
                        t.Encoding.decodeBase64String(
                          e[i.BeID.DataKindHints.PersonalInformationSignature],
                        ),
                      );
                    });
                case d.ADDRESS:
                  return r
                    .readData(this.newReader, i.BeID.DataKindHints.RawAddressInformation)
                    .then(function (e) {
                      return t.Encoding.encodeAsHexString(
                        t.Encoding.decodeBase64String(
                          e[i.BeID.DataKindHints.RawAddressInformation],
                        ),
                      );
                    });
                case d.ADDRESS_SIGNATURE:
                  return r
                    .readData(this.newReader, i.BeID.DataKindHints.AddressInformationSignature)
                    .then(function (e) {
                      return t.Encoding.encodeAsHexString(
                        t.Encoding.decodeBase64String(
                          e[i.BeID.DataKindHints.AddressInformationSignature],
                        ),
                      );
                    });
                case d.PHOTO:
                  return r.readData(this.newReader, i.BeID.DataKindHints.Photo).then(function (e) {
                    return e[i.BeID.DataKindHints.Photo];
                  });
                case l:
                  return r
                    .readCertificates(
                      this.newReader,
                      o.BeLawyer.CertificateKindHints.Authentication,
                    )
                    .then(function (e) {
                      return e.length > 0 ? e[0] : null;
                    })
                    .then(function (e) {
                      return null != e
                        ? t.Encoding.encodeAsHexString(t.Encoding.decodeBase64String(e))
                        : null;
                    });
                case p:
                  return r
                    .readCertificates(
                      this.newReader,
                      o.BeLawyer.CertificateKindHints.NonRepudiation,
                    )
                    .then(function (e) {
                      return e.length > 0 ? e[0] : null;
                    })
                    .then(function (e) {
                      return null != e
                        ? t.Encoding.encodeAsHexString(t.Encoding.decodeBase64String(e))
                        : null;
                    });
                case g:
                  return r
                    .readCertificates(
                      this.newReader,
                      o.BeLawyer.CertificateKindHints.IntermediateCa,
                    )
                    .then(function (e) {
                      return e.length > 0 ? e[0] : null;
                    })
                    .then(function (e) {
                      return null != e
                        ? t.Encoding.encodeAsHexString(t.Encoding.decodeBase64String(e))
                        : null;
                    });
                case f:
                  return r
                    .readCertificates(this.newReader, o.BeLawyer.CertificateKindHints.RootCa)
                    .then(function (e) {
                      return e.length > 0 ? e[0] : null;
                    })
                    .then(function (e) {
                      return null != e
                        ? t.Encoding.encodeAsHexString(t.Encoding.decodeBase64String(e))
                        : null;
                    });
                case E:
                  return r
                    .readData(this.newReader, o.BeLawyer.DataKindHints.PersonalInformation)
                    .then(function (e) {
                      return t.Encoding.encodeAsHexString(
                        t.Encoding.decodeBase64String(
                          e[o.BeLawyer.DataKindHints.PersonalInformation],
                        ),
                      );
                    });
                case R:
                  return r
                    .readData(this.newReader, o.BeLawyer.DataKindHints.Photo)
                    .then(function (e) {
                      return e[i.BeID.DataKindHints.Photo];
                    });
                case h:
                  return Promise.reject();
              }
              return Promise.reject(new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR));
            }),
            (e.prototype.readCertificates = function () {
              return this.newApi
                .getCardHandler(this.newReader)
                .readCertificates(
                  this.newReader,
                  i.BeID.CertificateKindHints.RootCa,
                  i.BeID.CertificateKindHints.CitizenCa,
                  i.BeID.CertificateKindHints.NonRepudiation,
                );
            }),
            (e.prototype.readAuthenticationCertificate = function () {
              return this.newApi
                .getCardHandler(this.newReader)
                .readCertificates(this.newReader, i.BeID.CertificateKindHints.Authentication)
                .then(function (e) {
                  return t.Encoding.decodeBase64String(e[0]);
                })
                .then(function (e) {
                  return t.Encoding.encodeAsHexString(e);
                });
            }),
            (e.prototype.readRootCertificate = function () {
              return this.newApi
                .getCardHandler(this.newReader)
                .readCertificates(this.newReader, i.BeID.CertificateKindHints.RootCa)
                .then(function (e) {
                  return t.Encoding.decodeBase64String(e[0]);
                })
                .then(function (e) {
                  return t.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return Promise.reject(
                    new c.plugin.PluginError(c.plugin.Errors.UNABLE_TO_READ_ROOT_CERT, { e: e }),
                  );
                });
            }),
            (e.prototype.readCaCertificate = function () {
              return this.newApi
                .getCardHandler(this.newReader)
                .readCertificates(this.newReader, i.BeID.CertificateKindHints.CitizenCa)
                .then(function (e) {
                  return t.Encoding.decodeBase64String(e[0]);
                })
                .then(function (e) {
                  return t.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return Promise.reject(
                    new c.plugin.PluginError(c.plugin.Errors.UNABLE_TO_READ_CA_CERT, { e: e }),
                  );
                });
            }),
            (e.prototype.readSignerCertificate = function () {
              return this.newApi
                .getCardHandler(this.newReader)
                .readCertificates(this.newReader, i.BeID.CertificateKindHints.NonRepudiation)
                .then(function (e) {
                  return t.Encoding.decodeBase64String(e[0]);
                })
                .then(function (e) {
                  return t.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return Promise.reject(
                    new c.plugin.PluginError(c.plugin.Errors.UNABLE_TO_READ_SIGNER_CERT, { e: e }),
                  );
                });
            }),
            (e.prototype.computeSignature = function (e, r, n) {
              return this.newApi
                .getCardHandler(this.newReader)
                .computeSignature(
                  this.newReader,
                  i.BeID.SignatureKindHints.NonRepudiation,
                  t.Encoding.decodeHexString(r),
                  e && e.length > 0 ? e : null,
                )
                .then(function (e) {
                  return t.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return e instanceof a.Exceptions.InvalidPinException
                    ? 0 === e.remainingTries || e.pinBlocked
                      ? Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.LOCKED_CARD, {
                            remainingAttempts: 0,
                          }),
                        )
                      : Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.INVALID_PIN, {
                            remainingAttempts: e.remainingTries,
                          }),
                        )
                    : e instanceof a.Exceptions.OperationCanceledException
                      ? Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.PIN_ENTRY_CANCEL_OR_TIMEOUT, {
                            e: e,
                          }),
                        )
                      : Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                        );
                });
            }),
            (e.prototype.computeAuthentication = function (e, r) {
              return this.newApi
                .getCardHandler(this.newReader)
                .computeSignature(
                  this.newReader,
                  i.BeID.SignatureKindHints.Authentication,
                  t.Encoding.decodeHexString(r),
                  e && e.length > 0 ? e : null,
                )
                .then(function (e) {
                  return t.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return e instanceof a.Exceptions.InvalidPinException
                    ? 0 === e.remainingTries || e.pinBlocked
                      ? Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.LOCKED_CARD, {
                            remainingAttempts: 0,
                          }),
                        )
                      : Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.INVALID_PIN, {
                            remainingAttempts: e.remainingTries,
                          }),
                        )
                    : e instanceof a.Exceptions.CardNotPresentException
                      ? Promise.reject(
                          new c.plugin.PluginError(c.plugin.Errors.NO_VALID_CARD_PRESENT, { e: e }),
                        )
                      : e instanceof a.Exceptions.OperationCanceledException
                        ? Promise.reject(
                            new c.plugin.PluginError(c.plugin.Errors.PIN_ENTRY_CANCEL_OR_TIMEOUT, {
                              e: e,
                            }),
                          )
                        : Promise.reject(
                            new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                          );
                });
            }),
            (e.prototype.readPersonalInformation = function (e) {
              return this.newApi
                .getCardHandler(this.newReader)
                .readData(this.newReader, i.BeID.DataKindHints.PersonalInformation)
                .then(function (e) {
                  return e[i.BeID.DataKindHints.PersonalInformation];
                })
                .catch(function (e) {
                  return Promise.reject(
                    new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                  );
                });
            }),
            (e.prototype.readAddress = function (e) {
              return this.newApi
                .getCardHandler(this.newReader)
                .readData(this.newReader, i.BeID.DataKindHints.AddressInformation)
                .then(function (e) {
                  return e[i.BeID.DataKindHints.AddressInformation];
                })
                .catch(function (e) {
                  return Promise.reject(
                    new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                  );
                });
            }),
            (e.prototype.readPhoto = function (e) {
              return this.newApi
                .getCardHandler(this.newReader)
                .readData(this.newReader, i.BeID.DataKindHints.Photo)
                .then(function (e) {
                  return e[i.BeID.DataKindHints.Photo];
                })
                .catch(function (e) {
                  return Promise.reject(
                    new c.plugin.PluginError(c.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                  );
                });
            }),
            (e.prototype.selectMaestro = function () {
              throw new Error('Method not implemented.');
            }),
            (e.prototype.getProcessingOptions = function (e) {
              throw new Error('Method not implemented.');
            }),
            (e.prototype.readRecord = function (e, r) {
              throw new Error('Method not implemented.');
            }),
            (e.prototype.readPrimaryAccountNumber = function () {
              throw new Error('Method not implemented.');
            }),
            (e.prototype.signTransactionNumber = function (e, r, n) {
              throw new Error('Method not implemented.');
            }),
            (e.prototype.getCardHandle = function (e) {
              return 'belawyer' === e
                ? Promise.resolve(
                    new s.BeLawyerCardHandleInterop(this.newApi, this.newReader, this),
                  )
                : Promise.resolve(this);
            }),
            e
          );
        })();
      r.ReaderInterop = P;
    },
    function (e, r, n) {
      'use strict';
      (Object.defineProperty(r, '__esModule', { value: !0 }), n(4), n(1), n(2), n(8));
    },
    function (e, r) {
      (!(function (e) {
        'use strict';
        var r = (e.connective = e.connective || {}),
          n = (r.utils = r.utils || {}),
          t = {
            Chrome: 0,
            Firefox: 1,
            InternetExplorer: 2,
            Safari: 3,
            Edge: 4,
            0: 'Chrome',
            1: 'Firefox',
            2: 'InternetExplorer',
            3: 'Safari',
            4: 'Edge',
          };
        n.BrowserKind = t;
        var i = {};
        ((n.BrowserUtils = i),
          (i.parseSemver = function (e) {
            var r = (e = e || '0.0.0').split('.');
            return {
              major: parseInt(r[0] || '0'),
              minor: parseInt(r[1] || '0'),
              patch: parseInt(r[2] || '0'),
            };
          }),
          (i.getBrowserInfo = function () {
            for (
              var e = navigator.userAgent,
                r = { browser: 'unknown', browserVersion: '0.0.0' },
                n = [
                  /Edge\/([0-9\.]+)/g,
                  /.*(?:Trident|MSIE).*rv:([0-9\.]+)/g,
                  /Chrome\/([0-9\.]+)/g,
                  /Firefox\/(\w+.\.\w+)/g,
                  /Version\/([0-9\.]+) Safari\/(?:[0-9\.]+)/g,
                ],
                o = [t.Edge, t.InternetExplorer, t.Chrome, t.Firefox, t.Safari],
                a = 0,
                s = n.length;
              a < s;
              a++
            ) {
              var c = n[a].exec(e);
              if (null != c)
                return ((r.browser = o[a]), (r.browserVersion = i.parseSemver(c[1])), r);
            }
            return r;
          }),
          (i.getFirefoxVersion = function () {
            var e = navigator.userAgent,
              r = /Firefox\/(\w+.\.\w+)/.exec(e);
            return r ? parseInt(r[1]) : -1;
          }),
          (i.getSafariVersion = function () {
            var e = navigator.userAgent,
              r = /Version\/([0-9\.]+) Safari\/(?:[0-9\.]+)/.exec(e),
              n = -1;
            return (r && (n = parseInt(r[1].split('.')[0])), n);
          }));
      })(window),
        (function (e) {
          'use strict';
          var r = (e.connective = e.connective || {}),
            n = (r.utils = r.utils || {}),
            t = (n.BrowserUtils = n.BrowserUtils || {}),
            i = function () {
              if (
                ((this.getInfoCmd = 'GET_INFO'),
                (this.getReadersCmd = 'GET_READERS'),
                (this.readFileCmd = 'READ_FILE'),
                (this.verifyPinCmd = 'VERIFY_PIN'),
                (this.computeSignatureCmd = 'COMPUTE_SIGNATURE'),
                (this.computeAuthenticationCmd = 'COMPUTE_AUTHENTICATION'),
                (this.pinPadAvailableCmd = 'PIN_PAD_AVAILABLE'),
                (this.getPadsCmd = 'GET_PADS'),
                (this.computeSignatureImageCmd = 'COMPUTE_SIGNATURE_IMAGE'),
                (this.selectMaestroCmd = 'SELECT_MAESTRO'),
                (this.getProcessingOptionsCmd = 'GET_PROCESSING_OPTIONS'),
                (this.readRecordCmd = 'READ_RECORD'),
                (this.signTransactionIdentificationNumberCmd = 'COMPUTE_SIGN_CHALLENGE'),
                (this.isIE = !1),
                (this.isChrome = !1),
                (this.isSafari = !1),
                (this.isFirefox = !1),
                (this.commandInProgress = null),
                navigator && navigator.userAgent)
              ) {
                var e = navigator.userAgent,
                  r = t.getFirefoxVersion(),
                  n = t.getSafariVersion();
                ((this.isChrome = -1 !== e.indexOf('Chrome') || r >= 52 || n >= 12),
                  this.isChrome ||
                    ((this.isIE =
                      e.indexOf('Trident') > 0 || navigator.userAgent.indexOf('MSIE') > 0),
                    this.isIE ||
                      ((this.isSafari = -1 !== e.toLowerCase().indexOf('safari/')),
                      this.isSafari ||
                        (this.isFirefox = -1 !== e.toLowerCase().indexOf('firefox/')))));
              }
              ((this.debug = !1),
                (this.applicationId = null),
                (this.activationResponse = null),
                (this.installedDivId = 'ConnectiveDocSignExtentionInstalled'),
                (this.lastWindow = null),
                (this.windowEventHandler = null),
                (this.activeXControl = null),
                (this.npapiPlugin = null));
            };
          ((e.ConnectiveDocSignApi = i),
            (i.prototype.init = function (e, r) {
              ((this.applicationId = e), (this.debug = r));
            }),
            (i.prototype.setActivationResponse = function (e) {
              this.activationResponse = e;
            }),
            (i.prototype.destroy = function () {
              (this.lastWindow &&
                this.windowEventHandler &&
                this.lastWindow.removeEventListener('message', this.windowEventHandler),
                (this.lastWindow = null),
                (this.windowEventHandler = null));
            }),
            (i.prototype.isExtensionInstalled = function () {
              return null !== document.getElementById(this.installedDivId);
            }),
            (i.prototype.getExtensionVersion = function () {
              var e = document.getElementById(this.installedDivId);
              if (null != e) return e.dataset.extensionVersion;
            }),
            (i.prototype.getInfo = function (e) {
              (this.log('getInfo'), this.processMessage(e, { cmd: this.getInfoCmd }));
            }),
            (i.prototype.getReaders = function (e) {
              (this.log('getReaders'), this.processMessage(e, { cmd: this.getReadersCmd }));
            }),
            (i.prototype.readFile = function (e, r, n) {
              (this.log('readFile', r),
                this.processMessage(n, { cmd: this.readFileCmd, reader: e, fileId: r }));
            }),
            (i.prototype.pinPadAvailable = function (e, r) {
              (this.log('pinPadAvailable'),
                this.processMessage(r, { cmd: this.pinPadAvailableCmd, reader: e }));
            }),
            (i.prototype.verifyPin = function (e, r, n, t) {
              this.log('verifyPin');
              var i = (n = n || {}).title,
                o = n.message;
              this.processMessage(
                function (e) {
                  var r = {};
                  (Object.keys(e).forEach(function (n) {
                    switch (n.toLowerCase()) {
                      case 'valid':
                        r.pinValid = e[n];
                        break;
                      case 'remainingattempts':
                        r.pinRemainingAttempts = e[n];
                        break;
                      default:
                        r[n] = e[n];
                    }
                  }),
                    t(r));
                },
                { cmd: this.verifyPinCmd, reader: e, pin: r, entry_title: i, entry_message: o },
              );
            }),
            (i.prototype.computeSignature = function (e, r, n, t, i, o) {
              this.log('computeSignature');
              var a = (i = i || {}).title,
                s = i.message;
              this.processMessage(o, {
                cmd: this.computeSignatureCmd,
                reader: e,
                pin: void 0 !== n ? void 0 : r,
                pinToken: n,
                hash: t,
                entry_title: a,
                entry_message: s,
              });
            }),
            (i.prototype.computeSignaturePKCS = function (e, r, n, t, i) {
              this.log('computeSignaturePKCS11');
              var o = o || {},
                a = o.title,
                s = o.message;
              this.processMessage(i, {
                cmd: this.computeSignatureCmd,
                reader: e,
                pin: null,
                pinToken: n,
                hash: r,
                entry_title: a,
                entry_message: s,
              });
            }),
            (i.prototype.computeAuthentication = function (e, r, n, t, i) {
              (console.log('computeAuthentication'),
                this.processMessage(i, {
                  cmd: this.computeAuthenticationCmd,
                  reader: e,
                  pin: void 0 !== n ? void 0 : r,
                  pinToken: n,
                  hash: t,
                }));
            }),
            (i.prototype.selectMaestro = function (e, r) {
              (console.log('selectMaestro'),
                this.processMessage(r, { cmd: this.selectMaestroCmd, reader: e }));
            }),
            (i.prototype.getProcessingOptions = function (e, r, n) {
              (console.log('getProcessingOptions'),
                this.processMessage(n, {
                  cmd: this.getProcessingOptionsCmd,
                  data: r || '8300',
                  reader: e,
                }));
            }),
            (i.prototype.readRecord = function (e, r, n, t) {
              (console.log('readRecord'),
                this.processMessage(t, { cmd: this.readRecordCmd, sfi: r, record: n, reader: e }));
            }),
            (i.prototype.signTransactionIdentificationNumber = function (e, r, n, t, i) {
              (console.log('signTransactionIdentificationNumber'),
                this.processMessage(i, {
                  cmd: this.signTransactionIdentificationNumberCmd,
                  transaction: r,
                  hash: n,
                  language: t,
                  reader: e,
                }));
            }),
            (i.prototype.getSignerPads = function (e) {
              (this.log('getPads'), this.processMessage(e, { cmd: this.getPadsCmd }));
            }),
            (i.prototype.computeSignatureImage = function (e, r, n, t, i) {
              (this.log('computeSignatureImage'),
                this.processMessage(i, {
                  cmd: this.computeSignatureImageCmd,
                  pad: e,
                  hash: r,
                  signer: n,
                  reason: t,
                }));
            }),
            (i.prototype.processMessage = function (e, r) {
              if (
                (this.log('processMessage', r),
                this.activationResponse && !this.activationResponse.error)
              ) {
                var n = this.activationResponse.activationToken;
                if (n) r.activationToken = n;
                else {
                  var t = this.activationResponse.activationTokenPlain;
                  t && (r.activationTokenPlain = { token: t.token, ttl: t.ttl });
                }
              }
              (this.debug && (r.debug = !0),
                delete r.pin,
                this.messenger
                  .sendMessage(r)
                  .then(function (r) {
                    e(r);
                  })
                  .catch(function (r) {
                    e(r);
                  }));
            }),
            (i.prototype.log = function (e, r) {
              this.debug && (console.log('[ConnectiveDocSignApi] ' + e), r && console.dir(r));
            }),
            (i.prototype.isActivationRequest = function (e) {
              return e.error && e.error.code && (e.error.code = 1e3);
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {}
          var n = (e.connective = e.connective || {});
          (((n.plugin = n.plugin || {}).BaseErrorProvider = r),
            (r.prototype.getErrorForResponse = function (e) {
              throw 'Unimplemented';
            }));
        })(window),
        (function (e, r, n) {
          'use strict';
          function t() {
            this.readerPollingDelay = 1e3;
          }
          var i = (e.connective = e.connective || {});
          (((i.plugin = i.plugin || {}).BasePluginApi = t),
            (t.prototype.initialize = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.checkIfPluginIsInstalled = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.activate = function (e) {
              throw 'Unimplemented';
            }),
            (t.prototype.getReaders = function (e) {
              throw 'Unimplemented';
            }),
            (t.prototype.getFirstAvailableReader = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.getSignerPads = function () {
              throw 'Unimplemented getSignerPads ' + this;
            }),
            (t.prototype.isPollingForReaders = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.pollForReader = function (e, r) {
              throw 'Unimplemented';
            }),
            (t.prototype.stopPollingForReader = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.isPollingForReader = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.pollForReaders = function (e, r) {
              throw 'Unimplemented';
            }),
            (t.prototype.stopPollingForReaders = function () {
              throw 'Unimplemented';
            }),
            (t.prototype.isInstalledPluginVersionSupported = function (e) {
              throw 'Unimplemented';
            }),
            (t.prototype.openBrowser = function (e) {
              throw 'Unimplemented';
            }));
        })(window, window.ConnectiveDocSignApi, window.Promise),
        (function (e, r) {
          'use strict';
          function n(e, r, n) {
            ((this.name = e),
              (this.type = r),
              (this.atr = n),
              (this.isCardPresent = null != this.atr && '' != this.atr),
              (this.CERT_IDS = {
                AUTHENTICATION: '3F00DF005038',
                SIGNER: '3F00DF005039',
                CA: '3F00DF00503A',
                ROOT: '3F00DF00503B',
                RN: '3F00DF00503C',
              }),
              (this.INFO_IDS = {
                PERSONAL: '3F00DF014031',
                PERSONAL_SIGNATURE: '3F00DF014032',
                ADDRESS: '3F00DF014033',
                ADDRESS_SIGNATURE: '3F00DF014034',
                PHOTO: '3F00DF014035',
              }));
          }
          var t = (e.connective = e.connective || {});
          (((t.plugin = t.plugin || {}).BaseReaderHandle = n),
            (n.prototype.isBluetoothReader = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.connect = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.isPinPadReader = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.validatePin = function (e, r) {
              throw 'Unimplemented';
            }),
            (n.prototype.readFile = function (e) {
              throw 'Unimplemented';
            }),
            (n.prototype.readCertificates = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.readAuthenticationCertificate = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.readRootCertificate = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.readCaCertificate = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.readSignerCertificate = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.computeSignature = function (e, r, n) {
              throw 'Unimplemented';
            }),
            (n.prototype.computeAuthentication = function (e, r) {
              throw 'Unimplemented';
            }),
            (n.prototype.readPersonalInformation = function (e) {
              throw 'Unimplemented';
            }),
            (n.prototype.readAddress = function (e) {
              throw 'Unimplemented';
            }),
            (n.prototype.readPhoto = function (e) {
              throw 'Unimplemented';
            }),
            (n.prototype.selectMaestro = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.getProcessingOptions = function (e) {
              throw 'Unimplemented';
            }),
            (n.prototype.readRecord = function (e, r) {
              throw 'Unimplemented';
            }),
            (n.prototype.readPrimaryAccountNumber = function () {
              throw 'Unimplemented';
            }),
            (n.prototype.signTransactionNumber = function (e, r, n) {
              throw 'Unimplemented';
            }),
            (n.prototype.getCardHandle = function (e) {
              throw 'BaseReaderHandle.getBeLawyerCardHandle unimplemented';
            }));
        })(window, window.Promise),
        (function (e) {
          'use strict';
          function r() {}
          var n = (e.connective = e.connective || {});
          (((n.plugin = n.plugin || {}).BaseSignerPadHandle = r),
            (r.computeSignatureImage = function (e, r, n) {
              throw 'unimplemented';
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e) {
            var r = this;
            ((r.data = e),
              (r.ptr = 0),
              (r.rewind = function () {
                r.ptr = 0;
              }),
              (r.next = function () {
                if (!(r.ptr >= r.data.length)) {
                  var e,
                    n = r.data[r.ptr++];
                  if (31 == (31 & n))
                    do {
                      n = (n << 8) | (e = r.data[r.ptr++]);
                    } while (128 == (128 & e));
                  var t = r.data[r.ptr++];
                  if (t >> 7 == 1) {
                    for (var i = 0, o = 0, a = 127 & t; o < a; o++) i = (i << 8) | r.data[r.ptr++];
                    t = i;
                  }
                  for (var s = [], c = 0, u = t; c < u; c++) s.push(r.data[r.ptr++]);
                  return { identifier: n, data: s };
                }
              }));
          }
          function n() {
            var e = this;
            ((e.fieldTypes = {}),
              (e.dataParsers = {}),
              (e.registerFieldType = function (r, n) {
                e.fieldTypes[r] = n;
              }),
              (e.registerDataParser = function (r, n) {
                e.dataParsers[r] = n;
              }),
              (e.parse = function (n) {
                for (var t, i, o, a = {}, s = new r(n); null != (t = s.next()); )
                  ((i = e.fieldTypes[t.identifier] || { name: t.identifier, kind: 'unkown' }),
                    (o = e.dataParsers[i.kind]),
                    (a[i.name] = null != o ? o(t.data) : t.data));
                return a;
              }),
              e.registerDataParser('tlv', function (r) {
                return e.parse(r);
              }));
          }
          var t = (e.connective = e.connective || {});
          ((t.BERTLVStream = r), (t.BERTLVParser = n));
          var i = (t.EMV = {}),
            o = new n();
          (o.registerFieldType(112, { name: 'aef', kind: 'tlv' }),
            o.registerFieldType(119, { name: 'aip-afl', kind: 'tlv' }),
            o.registerFieldType(130, { name: 'aip' }),
            o.registerFieldType(148, { name: 'afl', kind: 'afl' }),
            o.registerDataParser('afl', function (e) {
              if (e.length % 4 != 0) throw 'Incorrect AFL size...';
              for (var r, n, t, i, o = [], a = 0, s = e.length / 4; a < s; a++)
                ((r = e[4 * a] >> 3),
                  (n = e[4 * a + 1]),
                  (t = e[4 * a + 2]),
                  (i = e[4 * a + 3]),
                  o.push({ sfi: r, startRecord: n, endRecord: t, numAuthRecords: i }));
              return o;
            }),
            (i.AipAflParser = o));
          var a = new n();
          (a.registerFieldType(112, { name: 'aef', kind: 'tlv' }),
            a.registerFieldType(90, { name: 'pan', kind: 'pan' }),
            a.registerFieldType(24352, { name: 'cardholderName' }),
            a.registerFieldType(24356, { name: 'expirationDate' }),
            a.registerFieldType(24360, { name: 'issuerCountryCode' }),
            a.registerFieldType(24403, { name: 'iban' }),
            a.registerDataParser('pan', function (e) {
              return t.parseUtils.byteArrayToHexString(e);
            }),
            (i.RecordParser = a));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            var e = this;
            e.promise = new Promise(function (r, n) {
              ((e.promiseResolve = r), (e.promiseReject = n));
            });
          }
          var n = (e.connective = e.connective || {});
          ((r.prototype.then = function (e) {
            return this.promise.then(e);
          }),
            (r.prototype.catch = function (e) {
              return this.promise.catch(e);
            }),
            (r.prototype.resolve = function (e) {
              this.promiseResolve(e);
            }),
            (r.prototype.reject = function (e) {
              this.promiseReject(e);
            }),
            (n.Deferred = r));
        })(window),
        (function (e) {
          'use strict';
          function r(e, r) {
            var n = e === i.UNSPECIFIED_ERROR ? o.length - 1 : e,
              t = o[n] || '';
            ((this.code = e), (this.message = t), (this.stack = new Error().stack), (r = r || {}));
            for (var a, s = Object.keys(r), c = 0, u = s.length; c < u; c++)
              'message' !== (a = s[c]) && (this[a] = r[a]);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (t.Errors = n.ConnectivePluginApiError = r);
          ((i.CHROME_EXTENSION_NOT_INSTALLED = 0),
            (i.PLUGIN_NOT_INSTALLED = 1),
            (i.PLUGIN_NOT_ACTIVATED = 2),
            (i.NO_CARD_READERS_FOUND = 3),
            (i.NO_AVAILABLE_CARD_READER_FOUND = 4),
            (i.COULD_NOT_FIND_CARD_READER = 5),
            (i.NO_VALID_CARD_PRESENT = 6),
            (i.COMPUTE_SIGNATURE_FAILED = 7),
            (i.MALFORMED_PIN = 8),
            (i.INVALID_PIN = 9),
            (i.LOCKED_CARD = 10),
            (i.PLUGIN_NOT_ALLOWED_TO_RUN = 11),
            (i.PLUGIN_VERSION_NOT_SUPPORTED = 12),
            (i.COMPUTE_AUTHENTICATION_FAILED = 13),
            (i.UNSUPPORTED_FUNCTION_CALL = 14),
            (i.UNABLE_TO_READ_PAN = 15),
            (i.PIN_ENTRY_CANCEL_OR_TIMEOUT = 16),
            (i.UNABLE_TO_READ_SIGNER_CERT = 17),
            (i.UNABLE_TO_READ_ROOT_CERT = 18),
            (i.UNABLE_TO_READ_CA_CERT = 19),
            (i.BLUETOOTH_TRANSMISSION_FAILED = 20),
            (i.BLUETOOTH_CANT_CONNECT_WITH_READER = 21),
            (i.LOST_READER_CONNECTION = 22),
            (i.BLUETOOTH_PAIRING_ERROR = 23),
            (i.BLUETOOTH_OR_LOCATIONS_DISABLED = 24),
            (i.APP_IS_DEAD = 25),
            (i.FIREFOX_EXTENSION_NOT_INSTALLED = 26),
            (i.APP_GOT_SUSPENDED = 27),
            (i.CARD_BUSY = 28),
            (i.NO_SIGNER_PADS_FOUND = 29),
            (i.SIGNER_PAD_SIGNING_FAILED = 30),
            (i.SIGNER_PAD_ENTRY_CANCEL_OR_TIMEOUT = 31),
            (i.BROWSER_EXTENSION_NOT_SUPPORTED = 32),
            (i.SAFARI_EXTENSION_NOT_INSTALLED = 33),
            (i.EDGE_EXTENSION_NOT_INSTALLED = 34),
            (i.UNSPECIFIED_ERROR = 99));
          var o = [
            'Could not detect the required Connective chrome extension. Please visit http://plugin.connective.eu to install all necessary files',
            'Could not detect the required Connective plugin. Please visit http://plugin.connective.eu to install all necessary files.',
            'The Connective plugin has not been activated. Please activate it and try again!',
            'The plugin could not detect any card readers',
            'The plugin could not detect an available card reader. Make sure it is connected and a valid eID card is inserted',
            'The specified card reader could not be found',
            'Please insert a valid eID card',
            'The signature could not be computed. Please make sure your hash is 40 character hex string (e.g. 01FFAABD9DE8801F8FF001FFAABD9DE8801F8FF0)',
            'The provided pin was invalid. The pin should only contain numbers and should be at least 1 charater long',
            'The provided pin was incorrect.',
            'The eID was locked due to too many invalid pin inputs. Contact your local authority for more information on unlocking your card',
            "The Connective plugin was detected but is not allowed to run. To allow the plugin to run please check your browser's settings to enable the plugin.",
            'Your version of the connective plugin is no longer supported. Please visit http://plugin.connective.eu to get the latest version',
            'The authentication could not be computed. Please make sure your hash is 40 character hex string (e.g. 01FFAABD9DE8801F8FF001FFAABD9DE8801F8FF0)',
            'Trying to call a reader function that is not supported by the inserted card. EID cards do not allow EMV functionalities and vice versa',
            'Unable to read PAN from debit card',
            'The user cancelled the pin entry or waited too long before entering his/her pin',
            'Could not read the signer certificate',
            'Could not read the root certificate',
            'Could not read the ca certificate',
            'Bluetooth transaction failed. Please try again.',
            'There was a problem while trying to connect with the bluetooth reader. Please try again.',
            'The connection with the card reader was lost. Please try again.',
            'Bluetooth pairing failed. Please try again.',
            "Your devices' bluetooth or location is disabled. Please enable and try again.",
            'Mobile app is dead. Please restart',
            'Could not detect the required Connective firefox extension. Please visit http://plugin.connective.eu to install all necessary files',
            'Mobile app got suspended',
            'The inserted card could not be accessed because it is being used by another process',
            'Could not find any signer pads',
            'An error occured while retrieving the signature data from the signer pad.',
            'The signerpad signature entry was canceled or recieved a timeout',
            'The installed browser extension is not supported.',
            'Could not detect the required Connective safari 12+ extension. Please visit http://plugin.connective.eu to install all necessary files',
            'Could not detect the required Connective Edge extension. Please visit the Windows store and install the extension',
            'An unspecified error occured',
          ];
          ((r.prototype = Object.create(Error.prototype)),
            (r.prototype.constructor = r),
            (t.PluginError = r));
        })(window),
        (function (e, r) {
          'use strict';
          (e.connective = e.connective || {}).EventPromise = function () {
            function e(e) {
              n.resolve(e);
            }
            var n = this;
            (n.promise,
              n.resolve,
              n.reject,
              n.boundElement,
              n.boundEvent,
              (n.reset = function () {
                ((n.promise = new r(function (e, r) {
                  ((n.resolve = e), (n.reject = r));
                })),
                  (n.then = n.promise.then.bind(n.promise)),
                  (n.catch = n.promise.catch.bind(n.promise)));
              }),
              (n.bind = function (r, t) {
                (n.unbind(),
                  (n.boundElement = r),
                  (n.boundEvent = t),
                  n.boundElement.addEventListener(n.boundEvent, e));
              }),
              (n.unbind = function () {
                n.boundElement &&
                  n.boundEvent &&
                  (n.boundElement.removeEventListener(n.boundEvent, e),
                  (n.boundElement = void 0),
                  (n.boundEvent = void 0));
              }),
              n.reset());
          };
        })(window, window.Promise),
        (function (e) {
          'use strict';
          var r = (e.connective = e.connective || {}),
            n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
          r.parseUtils = new (function () {
            function e(e) {
              for (
                var r, t, i = String(e), o = 0, a = n, s = '';
                i.charAt(0 | o) || ((a = '='), o % 1);
                s += a.charAt(63 & (r >> (8 - (o % 1) * 8)))
              ) {
                if ((t = i.charCodeAt((o += 0.75))) > 255)
                  throw new Error(
                    '"btoa" failed: The string to be encoded contains characters outside of the Latin1 range.',
                  );
                r = (r << 8) | t;
              }
              return s;
            }
            function r(e) {
              var r = String(e).replace(/=+$/, '');
              if (r.length % 4 == 1)
                throw new Error(
                  '"atob" failed: The string to be decoded is not correctly encoded.',
                );
              for (
                var t, i, o = 0, a = 0, s = '';
                (i = r.charAt(a++));
                ~i && ((t = o % 4 ? 64 * t + i : i), o++ % 4)
                  ? (s += String.fromCharCode(255 & (t >> ((-2 * o) & 6))))
                  : 0
              )
                i = n.indexOf(i);
              return s;
            }
            var t = this;
            ((t.hexStrToByteArray = function (e) {
              for (
                var r = [], n = (e = e.replace(/(\s|0x)/g, '')).length / 2, t = 0;
                r.length < n;
              )
                (r.push(parseInt(e[t] + e[t + 1], 16)), (t += 2));
              return r;
            }),
              (t.byteArrayToHexString = function (e) {
                return e
                  .map(function (e) {
                    var r = e.toString(16);
                    return 1 === r.length ? '0' + r : r;
                  })
                  .join('')
                  .toUpperCase();
              }),
              (t.byteArrayToAsciiString = function (e) {
                for (var r = '', n = 0, t = e.length; n < t; n++) r += String.fromCharCode(e[n]);
                return r;
              }),
              (t.byteArrayToUtf8String = function (e) {
                for (var r, n, t = '', i = 0; i < e.length; )
                  (r = e[i++]) <= 191
                    ? (t += String.fromCharCode(r))
                    : r >= 194 && r < 224
                      ? ((n = ((31 & r) << 6) + (63 & e[i++])), (t += String.fromCharCode(n)))
                      : r >= 224 && r < 240
                        ? ((n = ((15 & r) << 12) + ((63 & e[i++]) << 6) + (63 & e[i++])),
                          (t += String.fromCharCode(n)))
                        : r >= 240 &&
                          r <= 244 &&
                          ((n =
                            ((7 & r) << 18) +
                            ((63 & e[i++]) << 12) +
                            ((63 & e[i++]) << 6) +
                            (63 & e[i++])),
                          (t += String.fromCharCode(n)));
                return t;
              }),
              (t.hexStrToBase64 = function (r) {
                return e(
                  String.fromCharCode.apply(
                    null,
                    r
                      .replace(/\r|\n/g, '')
                      .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
                      .replace(/ +$/, '')
                      .split(' '),
                  ),
                );
              }),
              (t.base64ToHexStr = function (e) {
                for (var n = r(e).split(''), t = [], i = '', o = 0, a = n.length; o < a; o++)
                  ((i = 1 === (i = n[o].charCodeAt(0).toString(16)).length ? '0' + i : i),
                    t.push(i));
                return t.join('');
              }),
              (t.btoa = e),
              (t.atob = r));
          })();
        })(window),
        (function (e) {
          'use strict';
          (e.connective = e.connective || {}).Range = function (e, r) {
            var n = this;
            ((n.from = Math.min(e, r)),
              (n.to = Math.max(e, r)),
              (n.asArray = function (e) {
                e instanceof Number || (e = 1);
                for (var r = [], t = n.from, i = n.to; t < i; t += e) r.push(t);
                return r;
              }));
          };
        })(window),
        (function (e, r) {
          'use strict';
          (window.connective = window.connective || {}).foreachSync = function (e, r) {
            var n = this || {};
            return (
              (n.index = 0),
              (n.items = e || []),
              (n.executeCallback = r || function () {}),
              (n.execute = function (e) {
                var r = n.executeCallback(e);
                'function' == typeof r.then
                  ? r.then(function () {
                      n.next();
                    })
                  : n.next();
              }),
              (n.next = function () {
                if (((n.index += 1), n.index === n.items.length)) return n.resolve();
                var e = n.items[n.index];
                n.execute(e);
              }),
              n.execute(n.items[n.index]),
              new Promise(function (e, r) {
                ((n.resolve = e), (n.reject = r));
              })
            );
          };
        })(window),
        (function (e) {
          'use strict';
          function r(e) {
            function r() {
              if (!(n.ptr >= n.data.length)) {
                var e = n.data[n.ptr++] || 0,
                  r = n.data[n.ptr++] || 0,
                  t = n.data.slice(n.ptr, n.ptr + r);
                return (
                  (n.ptr += r),
                  { id: e, bytes: t, value: i.parseUtils.byteArrayToAsciiString(t) }
                );
              }
            }
            var n = this;
            ((n.data = e), (n.ptr = 0), (n.fetchField = r), (n.fetchValue = r));
          }
          function n(e, n) {
            var t = this;
            ((t.fieldNameTable = e),
              (t.fieldEncodings = n),
              (t.parse = function (e) {
                for (var n, o = new r(e), a = {}; (n = o.fetchField()); )
                  ((a[t.fieldNameTable[n.id]] = n),
                    t.fieldEncodings[n.id] &&
                      (n.value = i.parseUtils.byteArrayToUtf8String(n.bytes)));
                return a;
              }));
          }
          function t() {
            function e(e) {
              for (
                var r = [
                    'JAN',
                    'FEV',
                    'MARS',
                    'AVR',
                    'MAI',
                    'JUIN',
                    'JUIL',
                    'AOUT',
                    'SEPT',
                    'OCT',
                    'NOV',
                    'DEC',
                  ],
                  n = [
                    'JAN',
                    'FEB',
                    'MAAR',
                    'APR',
                    'MEI',
                    'JUN',
                    'JUL',
                    'AUG',
                    'SEP',
                    'OKT',
                    'NOV',
                    'DEC',
                  ],
                  t = [
                    'JAN',
                    'FEB',
                    'MÄR',
                    'APR',
                    'MAI',
                    'JUN',
                    'JUL',
                    'AUG',
                    'SEP',
                    'OKT',
                    'NOV',
                    'DEZ',
                  ],
                  i = e.split(/\.|\s+|\//).filter(function (e) {
                    return null != e && e.length > 0;
                  }),
                  o = {
                    day: parseInt(i[0].trim()),
                    month: parseInt(i[1].trim()),
                    year: parseInt(i[2].trim()),
                  },
                  a = 0;
                a < 12;
                a++
              )
                if (i[1] === r[a] || i[1] === n[a] || i[1] === t[a]) {
                  o.month = a + 1;
                  break;
                }
              return o;
            }
            function r(e) {
              return 'M' === e ? 'male' : 'F' === e || 'V' === e || 'W' === e ? 'female' : 'unkown';
            }
            var t = this;
            ((t.tlvParser = new n(
              [
                'fileVersion',
                'cardNumber',
                'chipNumber',
                'cardValidityFrom',
                'cardValidityTo',
                'cardDeliveredIn',
                'nationalNumber',
                'name',
                'twoFirstGivenNames',
                'firstLetterOfThirdGivenName',
                'nationality',
                'birthLocation',
                'birthDate',
                'sex',
                'nobleCondition',
                'documentType',
                'specialStatus',
                'photoHash',
              ],
              [0, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 0, 1, 0, 0, 0],
            )),
              (t.parse = function (n) {
                for (
                  var i, o, a = t.tlvParser.parse(n), s = Object.keys(a), c = 0, u = s.length;
                  c < u;
                  c++
                )
                  switch (((i = s[c]), (o = a[i]), i)) {
                    case 'sex':
                      o.value = r(o.value);
                      break;
                    case 'birthDate':
                    case 'cardValidityFrom':
                    case 'cardValidityTo':
                      o.value = e(o.value);
                  }
                return a;
              }));
          }
          var i = (e.connective = e.connective || {});
          ((i.TLVStream = r),
            (i.TLVParser = n),
            (i.PersonalInformationParser = t),
            (e.PersonalInformationParser = t),
            (i.AddressParser = function () {
              var e = this;
              ((e.tlvParser = new n(
                ['fileVersion', 'streetAndNumber', 'zipCode', 'location'],
                [0, 1, 0, 1],
              )),
                (e.parse = e.tlvParser.parse.bind(e.tlvParser)));
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {}
          function n() {
            this.currentRequest = void 0;
          }
          var t = (e.connective = e.connective || {}),
            i = (t.androidSDK = t.androidSDK || {}),
            o = (t.plugin = t.plugin || {});
          ((n.prototype.constructor = n),
            (n.prototype.getReaders = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.getReaders(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.connectWithReader = function (e, r, n) {
              (this.initializeRequest(r, n),
                JsHandler.connectWithReader(
                  JSON.stringify(e),
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readFile = function (e, r, n) {
              this.initializeRequest(r, n);
              var t = e.match(/.{2}/g).join(':').toLowerCase();
              JsHandler.getFile(
                t,
                'connective.androidSDK.successHandler',
                'connective.androidSDK.errorHandler',
              );
            }),
            (n.prototype.readSignerCertificate = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readSignerCertificate(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readRootCertificate = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readRootCertificate(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readCaCertificate = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readCaCertificate(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readAuthenticationCertificate = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readAuthenticationCertificate(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readPhoto = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readPhoto(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readAddress = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readAddress(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.readPersonalInfo = function (e, r) {
              (this.initializeRequest(e, r),
                JsHandler.readPersonalInfo(
                  'connective.androidSDK.successHandler',
                  'connective.androidSDK.errorHandler',
                ));
            }),
            (n.prototype.computeSignature = function (e, r, n) {
              this.initializeRequest(r, n);
              var i = t.parseUtils.hexStrToBase64(e);
              JsHandler.computeSignature(
                i,
                'connective.androidSDK.successHandler',
                'connective.androidSDK.errorHandler',
              );
            }),
            (n.prototype.computeAuthentication = function (e, r, n) {
              this.initializeRequest(r, n);
              var i = t.parseUtils.hexStrToBase64(e);
              JsHandler.computeAuthentication(
                i,
                'connective.androidSDK.successHandler',
                'connective.androidSDK.errorHandler',
              );
            }),
            (n.prototype.openBrowser = function (e, r, n) {
              (this.initializeRequest(r, n), JsHandler.openBrowser(e));
            }),
            (n.prototype.initializeRequest = function (e, n) {
              if (this.currentRequest) throw 'Already executing a request...';
              this.currentRequest = { onSuccess: e || r, onError: n || r };
            }),
            (n.prototype.hasPendingRequest = function () {
              return null != this.currentRequest;
            }),
            (n.prototype.clearPendingRequest = function () {
              this.currentRequest = void 0;
            }),
            (i.bridge = new n()),
            (i.successHandler = function (e) {
              if (i.bridge.hasPendingRequest())
                try {
                  i.bridge.currentRequest.onSuccess(JSON.parse(e));
                } finally {
                  i.bridge.clearPendingRequest();
                }
              else
                (console.warn('received response but no currentRequest object exists (ignore)', e),
                  i.bridge.clearPendingRequest());
            }),
            (i.errorHandler = function (e) {
              var r = i.getErrorProvider();
              if (i.bridge.hasPendingRequest())
                try {
                  (JSON.parse(e), i.bridge.currentRequest.onError(r.getErrorForResponse(e)));
                } finally {
                  i.bridge.clearPendingRequest();
                }
              else
                (console.warn('received error but no currentRequest object exists (ignore)', e),
                  i.bridge.clearPendingRequest());
            }),
            (i.log = function (e) {
              console.log(e);
            }),
            (i.getErrorProvider = function () {
              return (
                i.errorProvider || (i.errorProvider = new o.AndroidErrorProvider()),
                i.errorProvider
              );
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            t.BaseErrorProvider.call(this);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (t.Errors = t.Errors || {}),
            o = t.PluginError,
            a = '-5100',
            s = '-5104',
            c = '-5106',
            u = '-5108',
            d = '-5138',
            l = '-5140',
            p = '-5142',
            g = '-5143',
            f = '-5193',
            E = '-5194',
            R = '6983',
            h = '63C',
            P = '-8001',
            A = '6401';
          ((r.prototype = Object.create(t.BaseErrorProvider.prototype)),
            (r.prototype.constructor = r),
            (t.AndroidErrorProvider = r),
            (r.prototype.getErrorForResponse = function (e) {
              if ('63C' === (e = JSON.parse(e)).code.substr(0, 3)) {
                var r = e.code.substr(e.code.length - 1);
                e.code = e.code.substr(0, 3);
              }
              switch (e.code) {
                case u:
                  return new o(i.BLUETOOTH_TRANSMISSION_FAILED, { e: e });
                case p:
                case d:
                  return new o(i.COULD_NOT_FIND_CARD_READER, { e: e });
                case h:
                  return 0 != r && parseInt(r)
                    ? new o(i.INVALID_PIN, { e: e, remainingAttempts: r })
                    : new o(i.LOCKED_CARD, { e: e });
                case R:
                  return new o(i.LOCKED_CARD, { e: e });
                case A:
                  return new o(i.PIN_ENTRY_CANCEL_OR_TIMEOUT, { e: e });
                case P:
                  return new o(i.COMPUTE_AUTHENTICATION_FAILED, { e: e });
                case f:
                case a:
                  return new o(i.BLUETOOTH_OR_LOCATIONS_DISABLED, { e: e });
                case g:
                case l:
                case d:
                  return new o(i.BLUETOOTH_CANT_CONNECT_WITH_READER, { e: e });
                case s:
                  return new o(i.LOST_READER_CONNECTION, { e: e });
                case E:
                  return new o(i.PERMISSION_DENIED, { e: e });
                case c:
                  return new o(i.APP_IS_DEAD, { e: e });
                default:
                  return new o(i.UNSPECIFIED_ERROR, { e: e });
              }
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            t.BasePluginApi.call(this);
          }
          e.androidDeferredPromises = {};
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = ((n.androidSDK = n.androidSDK || {}), /connective-app-android/);
          ((r.prototype = Object.create(t.BasePluginApi.prototype)),
            (r.prototype.constructor = r),
            (t.AndroidPluginApi = r),
            (r.prototype.initialize = function () {
              return Promise.resolve();
            }),
            (r.prototype.checkIfPluginIsInstalled = function () {
              var e = navigator.userAgent;
              return i.test(e)
                ? Promise.resolve()
                : Promise.reject(new t.PluginError(t.Errors.PLUGIN_NOT_INSTALLED));
            }),
            (r.prototype.activate = function (e) {
              return Promise.resolve();
            }),
            (r.prototype.getReaders = function (e) {
              var r = 0;
              return new Promise(function (e, i) {
                var o = function (s) {
                    var c = [];
                    (s.forEach(function (e) {
                      c.push(new t.AndroidReaderHandle(e, 'eid'));
                    }),
                      c && c.length > 0
                        ? e(c)
                        : r > 3
                          ? i(new t.PluginError(t.Errors.NO_CARD_READERS_FOUND))
                          : (r++,
                            setTimeout(function () {
                              n.androidSDK.bridge.getReaders(o, a);
                            }, 100)));
                  },
                  a = function (e) {
                    i(e);
                  };
                n.androidSDK.bridge.getReaders(o, a);
              });
            }),
            (r.prototype.getFirstAvailableReader = function () {
              return this.getReaders().then(function (e) {
                if (e.length > 0) return e[0];
                throw 'no readers available';
              });
            }),
            (r.prototype.isPollingForReaders = function () {
              return this.pollingForReaders;
            }),
            (r.prototype.pollForReader = function (r, n) {
              var i = this;
              ((r = r || i.readerPollingDelay), (n = n || 0));
              return new Promise(function (o, a) {
                i.pollingForReader = !0;
                var s = function () {
                  i.getFirstAvailableReader()
                    .then(function (e) {
                      o(e);
                    })
                    .catch(function (o) {
                      return o.code === t.Errors.PLUGIN_NOT_ACTIVATED
                        ? void a(o)
                        : ((retryCount += 1),
                          void (i.shouldStopPollingForReader || (n > 0 && retryCount >= n)
                            ? ((i.pollingForReader = !1),
                              (i.shouldStopPollingForReader = !1),
                              a(new t.PluginError(t.Errors.NO_AVAILABLE_CARD_READER_FOUND)))
                            : e.setTimeout(s, r)));
                    });
                };
                s();
              });
            }),
            (r.prototype.stopPollingForReader = function () {
              this.pollingForReaders && (this.shouldStopPollingForReaders = !0);
            }),
            (r.prototype.isPollingForReaders = function () {
              return this.pollingForReaders;
            }),
            (r.prototype.pollForReaders = function (r, n) {
              var i = this;
              return (
                (r = r || i.readerPollingDelay),
                new Promise(function (n, o) {
                  i.pollingForReaders = !0;
                  var a = function () {
                    (console.log('searching for readers...'),
                      i
                        .getReaders()
                        .then(function (e) {
                          if (0 === e.length) throw new Error('No readers found.');
                          ((i.pollingForReaders = !1), n(e));
                        })
                        .catch(function (n) {
                          return n.code === t.Errors.PLUGIN_NOT_ACTIVATED ||
                            n.code === t.Errors.APP_IS_DEAD
                            ? o(n)
                            : void (i.shouldStopPollingForReaders
                                ? ((i.pollingForReaders = !1),
                                  (i.shouldStopPollingForReaders = !1),
                                  o(new t.PluginError(t.Errors.NO_AVAILABLE_CARD_READER_FOUND)))
                                : e.setTimeout(a, r));
                        }));
                  };
                  a();
                })
              );
            }),
            (r.prototype.stopPollingForReaders = function () {
              this.pollingForReaders && (this.shouldStopPollingForReaders = !0);
            }),
            (r.prototype.isInstalledPluginVersionSupported = function (e) {
              return Promise.resolve(!0);
            }),
            (r.prototype.openBrowser = function (e) {
              n.androidSDK.bridge.openBrowser(e || 'https://www.esignatures.eu/#signatair-portal');
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e, r, n) {
            o.call(this, e, r, n);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (n.androidSDK = n.androidSDK || {}),
            o = t.BaseReaderHandle;
          ((r.prototype = Object.create(o.prototype)),
            (r.prototype.constructor = r),
            (t.AndroidReaderHandle = r),
            (r.prototype.isBluetoothReader = function () {
              return !0;
            }),
            (r.prototype.connect = function () {
              var e = this,
                r = 0;
              return new Promise(function (n, o) {
                var a = function (e) {
                    '3B9813400AA503010101AD1311' === e.toUpperCase()
                      ? n()
                      : o(new t.PluginError(t.Errors.NO_VALID_CARD_PRESENT));
                  },
                  s = function (n) {
                    r < 5
                      ? (r++,
                        setTimeout(function () {
                          i.bridge.connectWithReader(e.name, a, s);
                        }, 200))
                      : o(new t.PluginError(t.Errors.BLUETOOTH_CANT_CONNECT_WITH_READER, { e: n }));
                  };
                i.bridge.connectWithReader(e.name, a, s);
              });
            }),
            (r.prototype.isPinPadReader = function () {
              return Promise.resolve(!0);
            }),
            (r.prototype.validatePin = function (e, r) {
              return Promise.resolve();
            }),
            (r.prototype.readFile = function (e) {
              return new Promise(function (r, n) {
                i.bridge.readFile(
                  e,
                  function (e) {
                    r(e);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.readCertificates = function () {
              var e = this,
                r = {};
              return e
                .readCaCertificate()
                .then(function (n) {
                  return ((r.caCert = n), e.readSignerCertificate());
                })
                .then(function (n) {
                  return ((r.signerCert = n), e.readRootCertificate());
                })
                .then(function (n) {
                  return ((r.rootCert = n), e.readAuthenticationCertificate());
                })
                .then(function (e) {
                  return ((r.authenticationCert = e), r);
                });
            }),
            (r.prototype.readAuthenticationCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readAuthenticationCertificate(
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readRootCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readRootCertificate(
                  function (n) {
                    return '00' === n.substr(0, 2)
                      ? void r(new t.PluginError(t.Errors.UNABLE_TO_READ_ROOT_CERT))
                      : void e(n);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readCaCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readCaCertificate(
                  function (n) {
                    return '00' === n.substr(0, 2)
                      ? void r(new t.PluginError(t.Errors.UNABLE_TO_READ_CA_CERT))
                      : void e(n);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readSignerCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readSignerCertificate(
                  function (n) {
                    return '00' === n.substr(0, 2)
                      ? void r(new t.PluginError(t.Errors.UNABLE_TO_READ_SIGNER_CERT))
                      : void e(n);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.computeSignature = function (e, r, n) {
              return new Promise(function (e, n) {
                i.bridge.computeSignature(
                  r,
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.computeAuthentication = function (e, r) {
              return new Promise(function (e, n) {
                i.bridge.computeAuthentication(
                  r,
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.readPersonalInformation = function (e) {
              return new Promise(function (e, r) {
                i.bridge.readPersonalInfo(
                  function (i) {
                    try {
                      var o = n.parseUtils.hexStrToByteArray(i),
                        a = new n.PersonalInformationParser();
                      e(a.parse(o));
                    } catch (e) {
                      r(new t.PluginError(t.Errors.UNSPECIFIED_ERROR, { e: e }));
                    }
                  },
                  function (e) {
                    (console.log(e), r(e));
                  },
                );
              });
            }),
            (r.prototype.readAddress = function (e) {
              return new Promise(function (e, r) {
                i.bridge.readAddress(
                  function (i) {
                    try {
                      var o = n.parseUtils.hexStrToByteArray(i),
                        a = new n.AddressParser();
                      e(a.parse(o));
                    } catch (e) {
                      r(new t.PluginError(t.Errors.UNSPECIFIED_ERROR, { e: e }));
                    }
                  },
                  function (e) {
                    (console.log(e), r(e));
                  },
                );
              });
            }),
            (r.prototype.readPhoto = function (e) {
              return (
                (e = void 0 === e || e),
                new Promise(function (r, o) {
                  i.bridge.readPhoto(
                    function (i) {
                      try {
                        if (e) {
                          var a = n.parseUtils.hexStrToBase64(i);
                          r(a);
                        } else r(i.data);
                      } catch (e) {
                        o(new t.PluginError(t.Errors.UNSPECIFIED_ERROR, { e: e }));
                      }
                    },
                    function (e) {
                      o(e);
                    },
                  );
                })
              );
            }),
            (r.prototype.openAppSettings = function () {
              return new Promise(function (e, r) {
                i.bridge.openAppSettings(
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.selectMaestro = function () {
              throw 'Unimplemented';
            }),
            (r.prototype.getProcessingOptions = function (e) {
              throw 'Unimplemented';
            }),
            (r.prototype.readRecord = function (e, r) {
              throw 'Unimplemented';
            }),
            (r.prototype.readPrimaryAccountNumber = function () {
              throw 'Unimplemented';
            }),
            (r.prototype.signTransactionNumber = function (e, r, n) {
              throw 'Unimplemented';
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            t.BasePluginApi.call(this);
            var e = navigator.userAgent;
            e.match(/android.*mobile/i)
              ? (this.platformApi = new t.MobileBrowserPluginApi())
              : e.match(/(?:iphone|ipad).*mobile/i)
                ? (this.platformApi = new t.MobileBrowserPluginApi())
                : e.match(/connective-app-android/)
                  ? (this.platformApi = new t.AndroidPluginApi())
                  : e.match(/connective-app-ios/)
                    ? (this.platformApi = new t.IOSPluginApi())
                    : (this.platformApi = new t.DesktopPluginApi());
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {});
          ((r.prototype = Object.create(t.BasePluginApi.prototype)),
            (r.prototype.constructor = r),
            (t.AutoPlatformPluginApi = r),
            (n.ConnectivePluginApi = r),
            (r.prototype.initialize = function (e) {
              return this.platformApi.initialize(e);
            }),
            (r.prototype.checkIfPluginIsInstalled = function () {
              return this.platformApi.checkIfPluginIsInstalled();
            }),
            (r.prototype.activate = function (e) {
              return this.platformApi.activate(e);
            }),
            (r.prototype.getReaders = function (e) {
              return this.platformApi.getReaders(e);
            }),
            (r.prototype.getFirstAvailableReader = function () {
              return this.platformApi.getFirstAvailableReader();
            }),
            (r.prototype.pollForReader = function (e, r) {
              return this.platformApi.pollForReader(e, r);
            }),
            (r.prototype.stopPollingForReader = function () {
              return this.platformApi.stopPollingForReader();
            }),
            (r.prototype.isPollingForReader = function () {
              return this.platformApi.isPollingForReader();
            }),
            (r.prototype.pollForReaders = function (e, r) {
              return this.platformApi.pollForReaders(e, r);
            }),
            (r.prototype.stopPollingForReaders = function () {
              return this.platformApi.stopPollingForReaders();
            }),
            (r.prototype.isPollingForReaders = function () {
              return this.platformApi.isPollingForReaders();
            }),
            (r.prototype.isInstalledPluginVersionSupported = function (e) {
              return this.platformApi.isInstalledPluginVersionSupported();
            }),
            (r.prototype.openBrowser = function (e) {
              return this.platformApi.openBrowser(e);
            }),
            (r.prototype.getSignerPads = function () {
              return this.platformApi.getSignerPads();
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            t.BaseErrorProvider.call(this);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (t.Errors = t.Errors || {}),
            o = t.PluginError,
            a = {
              ERROR_CARD_READER_NOT_FOUND: 0,
              ERROR_CARD_READER_INVALID: 1,
              ERROR_LISTING_READERS_FAILED: 2,
              ERROR_INVALID_FILENAME: 3,
              ERROR_OUT_OF_MEMORY: 4,
              ERROR_FAILED_TO_READ_FILE: 5,
              ERROR_INVALID_PIN: 6,
              ERROR_INVALID_HASH: 7,
              ERROR_FAILED_TO_COMPUTE_SIGNATURE: 8,
              ERROR_MALFORMED_PIN: 9,
              ERROR_NEEDS_ACTIVATION: 10,
              ERROR_CANCEL_OR_TIMEOUT: 12,
              ERROR_CARD_BLOCKED: 13,
              ERROR_CARD_BUSY: 14,
              LISTING_SIGNING_PADS_FAILED: 20,
              SIGNER_PAD_NOT_FOUND: 21,
              SIGNER_PAD_SIGN_FAILED: 22,
              SIGNER_PAD_CANCEL_OR_TIMEOUT: 23,
              ERROR_UNSPECIFIED_ERROR: 99,
            };
          ((r.prototype = Object.create(t.BaseErrorProvider.prototype)),
            (r.prototype.constructor = r),
            (r.PLUGIN_ERRORS = a),
            (t.DesktopErrorProvider = r),
            (r.prototype.getErrorForResponse = function (e) {
              var r = e.error,
                n = e.pinValid;
              if (r)
                switch (r.id) {
                  case a.ERROR_NEEDS_ACTIVATION:
                    return new o(i.PLUGIN_NOT_ACTIVATED, { e: r });
                  case a.ERROR_CARD_READER_NOT_FOUND:
                    return new o(i.COULD_NOT_FIND_CARD_READER, { e: r });
                  case a.ERROR_CARD_READER_INVALID:
                    return new o(i.NO_VALID_CARD_PRESENT, { e: r });
                  case a.ERROR_MALFORMED_PIN:
                    return new o(i.MALFORMED_PIN, { e: r });
                  case a.ERROR_INVALID_PIN:
                    return 0 == e.pinRemainingAttempts || null == e.pinRemainingAttempts
                      ? new o(i.LOCKED_CARD, { e: r })
                      : new o(i.INVALID_PIN, { e: r, remainingAttempts: e.pinRemainingAttempts });
                  case a.ERROR_CANCEL_OR_TIMEOUT:
                    return new o(i.PIN_ENTRY_CANCEL_OR_TIMEOUT, { e: r });
                  case a.ERROR_CARD_BLOCKED:
                    return new o(i.LOCKED_CARD, { e: r });
                  case a.ERROR_INVALID_HASH:
                  case a.ERROR_FAILED_TO_COMPUTE_SIGNATURE:
                    return new o(i.COMPUTE_SIGNATURE_FAILED, { e: r });
                  case a.ERROR_FAILED_TO_COMPUTE_AUTHENTICATION:
                    return new o(i.COMPUTE_AUTHENTICATION_FAILED, { e: r });
                  case a.ERROR_CARD_BUSY:
                    return new o(i.CARD_BUSY, { e: r });
                  case a.SIGNER_PAD_SIGN_FAILED:
                    return new o(i.SIGNER_PAD_SIGNING_FAILED, { e: r });
                  case a.SIGNER_PAD_CANCEL_OR_TIMEOUT:
                    return new o(i.SIGNER_PAD_ENTRY_CANCEL_OR_TIMEOUT, { e: r });
                  default:
                    return new o(i.UNSPECIFIED_ERROR, { e: r });
                }
              else if (!1 === n)
                return 0 == e.pinRemainingAttempts || null == e.pinRemainingAttempts
                  ? new o(i.LOCKED_CARD, { e: r })
                  : new o(i.INVALID_PIN, { e: r, remainingAttempts: e.pinRemainingAttempts });
            }));
        })(window),
        (function (e, r, n) {
          'use strict';
          function t(e) {
            return (void 0 === a && ((a = new r()).messenger = e), a);
          }
          function i() {
            var e = this;
            (s.plugin.BasePluginApi.call(this),
              (e.version = '4.0.0'),
              (e.supportedExtensionVersions = ['1.0', '1.0.4']),
              (e.supportedPluginVersions = ['2.0.6']),
              (e.errorProvider = new c.DesktopErrorProvider()),
              (e.detector = null),
              (e.api = null),
              (e.pollingForReader = !1),
              (e.pollingForReaders = !1),
              (e.shouldStopPollingForReader = !1),
              (e.shouldStopPollingForReaders = !1),
              (e.alreadyFailedAtInitialize = !1),
              (e.pluginIsInstalled = !1));
          }
          function o(e) {
            var r = (e = e || '0.0.0').split('.');
            return { major: r[0] || '0', minor: r[1] || '0', patch: r[2] || '0' };
          }
          var a,
            s = (e.connective = e.connective || {}),
            c = (s.plugin = s.plugin || {});
          ((i.prototype = Object.create(s.plugin.BasePluginApi.prototype)),
            (i.prototype.constructor = i),
            (c.DesktopPluginApi = i),
            (i.prototype.initialize = function (e) {
              var r = this;
              return (
                e && e instanceof Array && e.length > 0 && (r.supportedPluginVersions = e),
                (r.detector = c.PluginDetector.getDetector({
                  pluginVersions: r.supportedPluginVersions,
                  extensionVersions: r.supportedExtensionVersions,
                })),
                r.detector.initialize().then(function () {
                  r.api = t(r.detector.messenger());
                })
              );
            }),
            (i.prototype.checkIfPluginIsInstalled = function () {
              return this.detector.detect();
            }),
            (i.prototype.activate = function (e) {
              return (this.api.setActivationResponse(e), n.resolve());
            }),
            (i.prototype.getReaders = function (e) {
              var r = this;
              return (
                (e = e instanceof Array ? e : ['eid', 'beid', 'emv', 'belawyer']),
                new n(function (t, i) {
                  r.api.getReaders(function (o) {
                    var a = r.errorProvider.getErrorForResponse(o);
                    if (a) i(a);
                    else if (o.readerList && o.readerList.length > 0) {
                      for (
                        var u = [],
                          d = n.resolve(),
                          l = function (r) {
                            d = d
                              .then(function () {
                                return s.smartcards.beid
                                  .readerContainsBeIDCard(r)
                                  .then(function (n) {
                                    if ((e.indexOf('eid') > -1 || e.indexOf('beid') > -1) && n)
                                      throw (u.push(r), 'detected');
                                  });
                              })
                              .then(function () {
                                return s.smartcards.belawyer
                                  .readerContainsBeLawyerCard(r)
                                  .then(function (n) {
                                    if (e.indexOf('belawyer') > -1 && n)
                                      throw (u.push(r), 'detected');
                                  });
                              })
                              .then(function () {
                                return s.smartcards.emv.readerContainsEmvCard(r).then(function (n) {
                                  if (e.indexOf('emv') > -1 && n) throw (u.push(r), 'detected');
                                });
                              })
                              .catch(function (e) {
                                if ('detected' !== e) return n.reject(e);
                              });
                          },
                          p = 0,
                          g = o.readerList.length;
                        p < g;
                        p++
                      )
                        l(
                          new c.DesktopReaderHandle(
                            o.readerList[p].name,
                            'unknown',
                            o.readerList[p].atr,
                            r,
                          ),
                        );
                      (d.then(function () {
                        t(u);
                      }),
                        d.catch(function (e) {
                          return new c.PluginError(c.Errors.UNSPECIFIED_ERROR, { e: e });
                        }));
                    } else i(new c.PluginError(c.Errors.NO_CARD_READERS_FOUND));
                  });
                })
              );
            }),
            (i.prototype.getFirstAvailableReader = function () {
              return this.getReaders().then(function (e) {
                if (e.length > 0) return e[0];
                throw new c.PluginError(c.Errors.NO_AVAILABLE_CARD_READER_FOUND);
              });
            }),
            (i.prototype.pollForReaders = function (r, t) {
              var i = this;
              return (
                (r = r || i.readerPollingDelay),
                (t = t || ['eid', 'beid', 'emv', 'belawyer']),
                new n(function (n, o) {
                  i.pollingForReaders = !0;
                  var a = function () {
                    i.getReaders(t)
                      .then(function (e) {
                        if (0 === e.length) throw new Error('No reader with cardPresent found.');
                        ((i.pollingForReaders = !1), n(e));
                      })
                      .catch(function (n) {
                        return n.code === c.Errors.PLUGIN_NOT_ACTIVATED
                          ? o(n)
                          : void (i.shouldStopPollingForReaders
                              ? ((i.pollingForReaders = !1),
                                (i.shouldStopPollingForReaders = !1),
                                o(new c.PluginError(c.Errors.NO_AVAILABLE_CARD_READER_FOUND)))
                              : e.setTimeout(a, r));
                      });
                  };
                  a();
                })
              );
            }),
            (i.prototype.stopPollingForReaders = function () {
              this.pollingForReaders && (this.shouldStopPollingForReaders = !0);
            }),
            (i.prototype.isPollingForReaders = function () {
              return this.pollingForReaders;
            }),
            (i.prototype.pollForReader = function (r, t) {
              var i = this,
                o = 0;
              return (
                (r = r || i.readerPollingDelay),
                (t = t || 0),
                new n(function (n, a) {
                  i.pollingForReader = !0;
                  var s = function () {
                    i.getFirstAvailableReader()
                      .then(function (e) {
                        ((i.pollingForReader = !1), n(e));
                      })
                      .catch(function (n) {
                        return n.code === c.Errors.PLUGIN_NOT_ACTIVATED
                          ? void a(n)
                          : ((o += 1),
                            void (i.shouldStopPollingForReader || (t > 0 && o >= t)
                              ? ((i.pollingForReader = !1),
                                (i.shouldStopPollingForReader = !1),
                                a(new c.PluginError(c.Errors.NO_AVAILABLE_CARD_READER_FOUND)))
                              : e.setTimeout(s, r)));
                      });
                  };
                  s();
                })
              );
            }),
            (i.prototype.stopPollingForReader = function () {
              this.pollingForReader && (this.shouldStopPollingForReader = !0);
            }),
            (i.prototype.isPollingForReader = function () {
              return this.pollingForReader;
            }),
            (i.prototype.getSignerPads = function () {
              var e = this;
              return new n(function (r, n) {
                e.api.getSignerPads(function (t) {
                  var i = e.errorProvider.getErrorForResponse(t);
                  if (i) n(i);
                  else if (t.padList && t.padList.length > 0) {
                    var o = [];
                    (t.padList.forEach(function (r) {
                      o.push(new c.DesktopSignerPadHandle(r.name, r.type, r.index, e.api));
                    }),
                      r(o));
                  } else n(c.Errors.NO_SIGNER_PADS_FOUND);
                });
              });
            }),
            (i.prototype.isInstalledPluginVersionSupported = function (e) {
              var r = !1;
              e.indexOf('-') > -1 && (e = e.substring(0, e.indexOf('-')));
              for (var n = o(e), t = 0, i = this.supportedPluginVersions.length; t < i; t++) {
                var a = o(this.supportedPluginVersions[t]);
                r = n.major >= a.major && n.minor >= a.minor && n.patch >= a.patch;
              }
              return r;
            }),
            (i.prototype.isInstalledExtensionVersionSupported = function (e) {
              for (var r = !1, n = 0, t = this.supportedExtensionVersions.length; n < t; n++) {
                var i = o(this.supportedExtensionVersions[n]);
                if (!0 === (r = e.major >= i.major && e.minor >= i.minor && e.patch >= i.patch))
                  break;
              }
              return r;
            }),
            (i.prototype.openBrowser = function (e) {
              window.location = e;
            }));
        })(window, window.ConnectiveDocSignApi, window.Promise),
        (function (e, r) {
          'use strict';
          function n(e, r, n, t) {
            (i.BaseReaderHandle.call(this, e, r, n),
              (this.pluginApi = t),
              (this.api = t.api),
              (this.errorProvider = new o()));
          }
          var t = (e.connective = e.connective || {}),
            i = (t.plugin = t.plugin || {}),
            o = i.DesktopErrorProvider;
          ((n.prototype = Object.create(i.BaseReaderHandle.prototype)),
            (n.prototype.constructor = n),
            (i.DesktopReaderHandle = n),
            (n.prototype.connect = function () {
              return r.resolve();
            }),
            (n.prototype.isBluetoothReader = function () {
              return !1;
            }),
            (n.prototype.isPinPadReader = function () {
              var e = this;
              return new r(function (r, n) {
                e.api.pinPadAvailable(e.name, function (t) {
                  var i = e.errorProvider.getErrorForResponse(t);
                  return i ? void n(i) : void r(t.available);
                });
              });
            }),
            (n.prototype.validatePin = function (e, n) {
              var t = this;
              return new r(function (r, o) {
                return 'beid' !== t.type && 'belawyer' !== t.type
                  ? void o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void t.api.verifyPin(t.name, e, n, function (e) {
                      var n = t.errorProvider.getErrorForResponse(e);
                      return n
                        ? void o(n)
                        : void (e.pinValid
                            ? (t.updateLastPinTokenFromPluginResponse(e), r(e.pinToken))
                            : o(
                                new i.PluginError(i.Errors.INVALID_PIN, {
                                  remainingAttempts: e.pinRemainingAttempts,
                                }),
                              ));
                    });
              });
            }),
            (n.prototype.readFile = function (e) {
              var n = this;
              return new r(function (r, t) {
                n.api.readFile(n.name, e, function (e) {
                  var i = n.errorProvider.getErrorForResponse(e);
                  i ? t(i) : r(e.data);
                });
              });
            }),
            (n.prototype.readCertificates = function () {
              var e,
                n,
                t,
                a,
                s = this;
              return new r(function (r, c) {
                return 'beid' !== s.type
                  ? void c(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void s.api.readFile(s.name, s.CERT_IDS.ROOT, function (u) {
                      var d = s.errorProvider.getErrorForResponse(u);
                      return d
                        ? (u.error.id === o.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE &&
                            (d = new i.PluginError(i.Errors.UNABLE_TO_READ_ROOT_CERT, { e: d.e })),
                          void c(d))
                        : ((n = u.data),
                          void s.api.readFile(s.name, s.CERT_IDS.CA, function (u) {
                            var d = s.errorProvider.getErrorForResponse(u);
                            return d
                              ? (u.error.id === o.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE &&
                                  (d = new i.PluginError(i.Errors.UNABLE_TO_READ_CA_CERT, {
                                    e: d.e,
                                  })),
                                void c(d))
                              : ((t = u.data),
                                void s.api.readFile(s.name, s.CERT_IDS.SIGNER, function (u) {
                                  var d = s.errorProvider.getErrorForResponse(u);
                                  return d
                                    ? (u.error.id === o.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE &&
                                        (d = new i.PluginError(
                                          i.Errors.UNABLE_TO_READ_SIGNER_CERT,
                                          { e: d.e },
                                        )),
                                      void c(d))
                                    : ((a = u.data),
                                      void s.api.readFile(
                                        s.name,
                                        s.CERT_IDS.AUTHENTICATION,
                                        function (i) {
                                          var o = s.errorProvider.getErrorForResponse(i);
                                          return o
                                            ? void c(o)
                                            : ((e = i.data),
                                              void r({
                                                rootCert: n,
                                                caCert: t,
                                                signerCert: a,
                                                authenticationCert: e,
                                              }));
                                        },
                                      ));
                                }));
                          }));
                    });
              });
            }),
            (n.prototype.readAuthenticationCertificate = function () {
              var e = this;
              return new r(function (r, n) {
                return 'beid' !== e.type
                  ? void n(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void e.api.readFile(e.name, e.CERT_IDS.AUTHENTICATION, function (t) {
                      var i = e.errorProvider.getErrorForResponse(t);
                      return i ? void n(i) : void r(t.data);
                    });
              });
            }),
            (n.prototype.readRootCertificate = function () {
              var e = this;
              return new r(function (r, n) {
                return 'beid' !== e.type
                  ? void n(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void e.api.readFile(e.name, e.CERT_IDS.ROOT, function (t) {
                      var a = e.errorProvider.getErrorForResponse(t);
                      return a
                        ? (t.error.id === o.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE &&
                            (a = new i.PluginError(i.Errors.UNABLE_TO_READ_ROOT_CERT, { e: a.e })),
                          void n(a))
                        : '00' === t.data.substr(0, 2)
                          ? void n(new i.PluginError(i.Errors.UNABLE_TO_READ_ROOT_CERT))
                          : void r(t.data);
                    });
              });
            }),
            (n.prototype.readCaCertificate = function () {
              var e = this;
              return new r(function (r, n) {
                return 'beid' !== e.type
                  ? void n(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void e.api.readFile(e.name, e.CERT_IDS.CA, function (t) {
                      var a = e.errorProvider.getErrorForResponse(t);
                      return a
                        ? (t.error.id === o.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE &&
                            (a = new i.PluginError(i.Errors.UNABLE_TO_READ_CA_CERT, { e: a.e })),
                          void n(a))
                        : '00' === t.data.substr(0, 2)
                          ? void n(new i.PluginError(i.Errors.UNABLE_TO_READ_CA_CERT))
                          : void r(t.data);
                    });
              });
            }),
            (n.prototype.readSignerCertificate = function () {
              var e = this;
              return new r(function (r, n) {
                return 'beid' !== e.type
                  ? void n(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void e.api.readFile(e.name, e.CERT_IDS.SIGNER, function (t) {
                      var a = e.errorProvider.getErrorForResponse(t);
                      return a
                        ? (t.error.id === o.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE &&
                            (a = new i.PluginError(i.Errors.UNABLE_TO_READ_SIGNER_CERT, {
                              e: a.e,
                            })),
                          void n(a))
                        : '00' === t.data.substr(0, 2)
                          ? void n(new i.PluginError(i.Errors.UNABLE_TO_READ_SIGNER_CERT))
                          : void r(t.data);
                    });
              });
            }),
            (n.prototype.computeSignature = function (e, n, t) {
              var o = this;
              return new r(function (r, a) {
                if ('beid' === o.type || 'belawyer' === o.type) {
                  var s = e;
                  /(1\.0\.0).+/.exec(o.pluginApi.pluginVersion) && (s = void 0);
                  var c = function (e) {
                    var n = o.errorProvider.getErrorForResponse(e);
                    return n
                      ? void a(n)
                      : void (void 0 !== e.signature
                          ? (o.updateLastPinTokenFromPluginResponse(e), r(e.signature))
                          : a(new i.PluginError(i.Errors.COMPUTE_SIGNATURE_FAILED)));
                  };
                  switch (o.type) {
                    case 'belawyer':
                      o.api.computeSignaturePKCS(o.name, n, s, t, c);
                      break;
                    default:
                      o.api.computeSignature(o.name, e, s, n, t, c);
                  }
                } else a(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL));
              });
            }),
            (n.prototype.computeAuthentication = function (e, n) {
              var t = this;
              return new r(function (r, o) {
                if ('beid' === t.type || 'belawyer' === t.type) {
                  var a = e;
                  (/(1\.0\.0).+/.exec(t.pluginApi.pluginVersion) && (a = void 0),
                    t.api.computeAuthentication(t.name, e, a, n, function (e) {
                      var n = t.errorProvider.getErrorForResponse(e);
                      return n
                        ? void o(n)
                        : void (void 0 !== e.signature
                            ? r(e.signature)
                            : o(new i.PluginError(i.Errors.COMPUTE_SIGNATURE_FAILED)));
                    }));
                } else o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL));
              });
            }),
            (n.prototype.readPersonalInformation = function (e) {
              var n = this;
              return (
                (e = void 0 === e || e),
                new r(function (r, o) {
                  return 'beid' !== n.type
                    ? void o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                    : void n.api.readFile(n.name, n.INFO_IDS.PERSONAL, function (a) {
                        var s = n.errorProvider.getErrorForResponse(a);
                        if (s) o(s);
                        else
                          try {
                            if (e) {
                              var c = t.parseUtils.hexStrToByteArray(a.data),
                                u = new t.PersonalInformationParser();
                              r(u.parse(c));
                            } else r(a.data);
                          } catch (e) {
                            o(new i.PluginError(i.Errors.UNSPECIFIED_ERROR, { e: e }));
                          }
                      });
                })
              );
            }),
            (n.prototype.readAddress = function (e) {
              var n = this;
              return (
                (e = void 0 === e || e),
                new r(function (r, o) {
                  return 'beid' !== n.type
                    ? void o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                    : void n.api.readFile(n.name, n.INFO_IDS.ADDRESS, function (a) {
                        var s = n.errorProvider.getErrorForResponse(a);
                        if (s) o(s);
                        else
                          try {
                            if (e) {
                              var c = t.parseUtils.hexStrToByteArray(a.data),
                                u = new t.AddressParser();
                              r(u.parse(c));
                            } else r(a.data);
                          } catch (e) {
                            o(new i.PluginError(i.Errors.UNSPECIFIED_ERROR, { e: e }));
                          }
                      });
                })
              );
            }),
            (n.prototype.readPhoto = function (e) {
              var n = this;
              return (
                (e = void 0 === e || e),
                new r(function (r, o) {
                  return 'beid' !== n.type
                    ? void o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                    : void n.api.readFile(n.name, n.INFO_IDS.PHOTO, function (a) {
                        var s = n.errorProvider.getErrorForResponse(a);
                        if (s) o(s);
                        else
                          try {
                            if (e) {
                              var c = t.parseUtils.hexStrToBase64(a.data);
                              r(c);
                            } else r(a.data);
                          } catch (e) {
                            o(new i.PluginError(i.Errors.UNSPECIFIED_ERROR, { e: e }));
                          }
                      });
                })
              );
            }),
            (n.prototype.selectMaestro = function () {
              var e = this;
              return new r(function (r, n) {
                e.api.selectMaestro(e.name, function (t) {
                  var i = e.errorProvider.getErrorForResponse(t);
                  return i ? void n(i) : void r(t);
                });
              });
            }),
            (n.prototype.getProcessingOptions = function (e) {
              var n = this;
              return new r(function (r, o) {
                return 'emv' !== n.type
                  ? void o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void n.api.getProcessingOptions(n.name, e, function (e) {
                      var i = n.errorProvider.getErrorForResponse(e);
                      if (i) o(i);
                      else {
                        var a = t.EMV.AipAflParser;
                        r(a.parse(t.parseUtils.hexStrToByteArray(e.data)));
                      }
                    });
              });
            }),
            (n.prototype.readRecord = function (e, n) {
              var o = this;
              return new r(function (r, a) {
                return 'emv' !== o.type
                  ? void a(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void o.api.readRecord(o.name, e, n, function (e) {
                      var n = o.errorProvider.getErrorForResponse(e);
                      if (n) a(n);
                      else {
                        var i = t.EMV.RecordParser;
                        r(i.parse(t.parseUtils.hexStrToByteArray(e.data)));
                      }
                    });
              });
            }),
            (n.prototype.readPrimaryAccountNumber = function () {
              var e = this;
              return new r(function (n, o) {
                return 'emv' !== e.type
                  ? void o(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                  : void e
                      .selectMaestro()
                      .then(function () {
                        return e.getProcessingOptions();
                      })
                      .then(function (a) {
                        var s = r.resolve(),
                          c = !1;
                        (a['aip-afl'].afl.forEach(function (r) {
                          new t.Range(r.startRecord, r.endRecord + 1)
                            .asArray()
                            .forEach(function (t) {
                              s = s
                                .then(function () {
                                  return !c && e.readRecord(r.sfi, t);
                                })
                                .then(function (e) {
                                  if (null != e.aef.pan) {
                                    c = !0;
                                    var r = e.aef.pan.substr(0, e.aef.pan.length - 1);
                                    n(r);
                                  }
                                })
                                .catch(function () {});
                            });
                        }),
                          s
                            .then(function () {
                              o(new i.PluginError(i.Errors.UNABLE_TO_READ_PAN));
                            })
                            .catch(function (e) {
                              o(e);
                            }));
                      });
              });
            }),
            (n.prototype.signTransactionNumber = function (e, n, t) {
              var o = this;
              return (
                (t = ['nl', 'de', 'fr'].indexOf(t) > -1 ? t : 'nl'),
                new r(function (r, a) {
                  return 'emv' !== o.type && 'beid' !== o.type
                    ? void a(new i.PluginError(i.Errors.UNSUPPORTED_FUNCTION_CALL))
                    : void o.api.signTransactionIdentificationNumber(o.name, e, n, t, function (e) {
                        var n = o.errorProvider.getErrorForResponse(e);
                        return n ? void a(n) : void r(e);
                      });
                })
              );
            }),
            (n.prototype.updateLastPinTokenFromPluginResponse = function (e) {
              null != e.pinToken && (this.lastPinToken = e.pinToken);
            }),
            (n.prototype.getCardHandle = function (e) {
              var n = this;
              return new r(function (r, i) {
                switch (e) {
                  case 'belawyer':
                    return t.smartcards.belawyer
                      .readerContainsBeLawyerCard(n)
                      .then(function (e) {
                        (e && r(new t.smartcards.belawyer.BeLawyerCardHandler(n)), e || i());
                      })
                      .catch(function (e) {
                        i();
                      });
                  case 'beid':
                    return connetive.smartcards.beid
                      .readerContainsBeIDCard(n)
                      .then(function (e) {
                        (e && r(n), e || i());
                      })
                      .catch(function (e) {
                        i();
                      });
                  case 'emv':
                    return t.smartcards.emv
                      .readerContainsEmvCard(n)
                      .then(function (e) {
                        (e && r(n), e || i());
                      })
                      .catch(function (e) {
                        i();
                      });
                }
              });
            }));
        })(window, window.Promise),
        (function (e) {
          'use strict';
          function r(e, r, n, o) {
            (t.BaseSignerPadHandle.apply(this),
              (this.name = e),
              (this.type = r),
              (this.index = n),
              (this.api = o),
              (this.errorProvider = new i()));
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = t.DesktopErrorProvider;
          ((r.prototype = Object.create(t.BaseSignerPadHandle.prototype)),
            (r.prototype.constructor = r),
            (t.DesktopSignerPadHandle = r),
            (r.prototype.computeSignatureImage = function (e, r, n) {
              var t = this;
              return new Promise(function (i, o) {
                t.api.computeSignatureImage(t.name, e, r, n, function (e) {
                  setTimeout(i({ metadata: e.metadata, image: e.image }));
                });
              });
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e, r) {
            ((this.config = e || { pluginVersions: [], extensionVersions: [] }),
              (this.pluginMessenger = r));
          }
          function n(e) {
            (r.call(this, e, new s.NativeMessagingHostMessenger()),
              (this.ExtensionElementName = 'ConnectiveDocSignExtentionInstalled'));
          }
          function t(e) {
            r.call(this, e, new s.NPAPIMessenger());
          }
          function i(e) {
            r.call(this, e, new s.ActiveXMessenger());
          }
          function o(e) {
            (n.call(this, e), t.call(this, e), (this.pluginMessenger = null));
          }
          var a = (e.connective = e.connective || {}),
            s = (a.plugin = a.plugin || {}),
            c = (a.utils = a.utils || {}),
            u = (c.BrowserUtils = c.BrowserUtils || {});
          ((r.prototype.initialize = function () {
            return Promise.reject('PluginDetector.initialize is not implemented for ' + this);
          }),
            (r.prototype.detect = function () {
              var e = this;
              return new Promise(function (r, n) {
                var t = setTimeout(function () {
                  n(new s.PluginError(s.Errors.PLUGIN_NOT_INSTALLED));
                }, 5e3);
                e.messenger()
                  .sendMessage({ cmd: 'GET_INFO' })
                  .then(function (i) {
                    clearTimeout(t);
                    for (
                      var o = u.parseSemver(i.binVersion),
                        a = 0,
                        c = e.config.pluginVersions.length;
                      a < c;
                      a++
                    ) {
                      var d = u.parseSemver(e.config.pluginVersions[a]);
                      if (o.major >= d.major && o.minor >= d.minor && o.patch >= d.patch)
                        return r(o);
                    }
                    n(new s.PluginError(s.Errors.PLUGIN_VERSION_NOT_SUPPORTED));
                  })
                  .catch(function (e) {
                    n(e);
                  });
              });
            }),
            (r.prototype.supportedPluginVersions = function () {
              return this.config.pluginVersions.slice();
            }),
            (r.prototype.supportedExtensionVersions = function () {
              return this.config.extensionVersions.slice();
            }),
            (r.prototype.queryPlugin = function () {
              return Promise.reject('PluginDetector.queryPlugin is not implemented for ' + this);
            }),
            (r.prototype.messenger = function () {
              return this.pluginMessenger;
            }),
            (r.prototype.browserInfo = function () {
              return this.config.browserInfo;
            }),
            (s.PluginDetector = r),
            (r.getDetector = function (e) {
              var r = c.BrowserUtils.getBrowserInfo();
              switch (
                (((e = e || { pluginVersions: [], extensionVersions: [] }).browserInfo = r),
                r.browser)
              ) {
                case c.BrowserKind.Chrome:
                  return new n(e);
                case c.BrowserKind.Firefox:
                  return r.browserVersion.major >= 52 ? new n(e) : new t(e);
                case c.BrowserKind.Safari:
                  return r.browserVersion.major >= 12
                    ? new n(e)
                    : 11 === r.browserVersion.major
                      ? new o(e)
                      : new t(e);
                case c.BrowserKind.InternetExplorer:
                  return new i(e);
                case c.BrowserKind.Edge:
                  return new n(e);
              }
            }),
            (n.prototype = Object.create(r.prototype)),
            (n.prototype.constructor = n),
            (n.prototype.initialize = function () {
              var e = this;
              return new Promise(function (r, n) {
                setTimeout(function () {
                  if (!e.isExtensionInstalled())
                    switch (e.browserInfo().browser) {
                      case c.BrowserKind.Chrome:
                        return n(new s.PluginError(s.Errors.CHROME_EXTENSION_NOT_INSTALLED));
                      case c.BrowserKind.Firefox:
                        return n(new s.PluginError(s.Errors.FIREFOX_EXTENSION_NOT_INSTALLED));
                      case c.BrowserKind.Safari:
                        return n(new s.PluginError(s.Errors.SAFARI_EXTENSION_NOT_INSTALLED));
                      case c.BrowserKind.Edge:
                        return n(new s.PluginError(s.Errors.EDGE_EXTENSION_NOT_INSTALLED));
                    }
                  for (
                    var t = e.extensionVersion(), i = 0, o = e.config.extensionVersions.length;
                    i < o;
                    i++
                  ) {
                    var a = u.parseSemver(e.config.extensionVersions[i]);
                    if (t.major >= a.major && t.minor >= a.minor && t.patch >= a.patch) return r();
                  }
                  return n(new s.PluginError(s.Errors.BROWSER_EXTENSION_NOT_SUPPORTED));
                }, 50);
              });
            }),
            (n.prototype.extensionVersion = function () {
              var e = document.getElementById(this.ExtensionElementName);
              return null == e
                ? { major: 0, minor: 0, patch: 0 }
                : u.parseSemver(e.dataset.extensionVersion || '0.0.0');
            }),
            (n.prototype.isExtensionInstalled = function () {
              return null != document.getElementById(this.ExtensionElementName);
            }),
            (s.NativeMessagingDetector = n),
            (t.prototype = Object.create(r.prototype)),
            (t.prototype.constructor = t),
            (t.prototype.initialize = function () {
              return (
                this.messenger().npapiElement(),
                this.pluginMimeTypeIsPresent()
                  ? Promise.resolve()
                  : Promise.reject(new s.PluginError(s.Errors.PLUGIN_NOT_INSTALLED))
              );
            }),
            (t.prototype.pluginMimeTypeIsPresent = function () {
              navigator.plugins.refresh(!1);
              var e = navigator.mimeTypes;
              for (var r in e) if ('application/x-connectivesignerplugin' === e[r].type) return !0;
              return !1;
            }),
            (s.NPAPIDetector = t),
            (i.prototype = Object.create(r.prototype)),
            (i.prototype.constructor = i),
            (i.prototype.initialize = function () {
              return (this.messenger().activeXElement(), Promise.resolve());
            }),
            (o.prototype = Object.create(r.prototype)),
            (o.prototype.constructor = o),
            (o.prototype.initialize = function () {
              var e = this;
              return n.prototype.initialize
                .call(e)
                .then(function () {
                  e.pluginMessenger = new s.NativeMessagingHostMessenger();
                })
                .catch(function (r) {
                  return r && r.code !== s.Errors.SAFARI_EXTENSION_NOT_INSTALLED
                    ? Promise.reject(r)
                    : ((e.pluginMessenger = new s.NPAPIMessenger()),
                      t.prototype.initialize.call(e));
                });
            }),
            (o.prototype.extensionVersion = n.prototype.extensionVersion),
            (o.prototype.isExtensionInstalled = n.prototype.isExtensionInstalled),
            (o.prototype.pluginMimeTypeIsPresent = t.prototype.pluginMimeTypeIsPresent),
            (s.SafariDetector = o));
        })(window),
        (function (e) {
          'use strict';
          function r() {}
          function n() {
            r.apply(this);
          }
          function t() {
            r.apply(this);
          }
          function i() {
            r.apply(this);
          }
          var o = (e.connective = e.connective || {}),
            a = (o.plugin = o.plugin || {});
          ((r.prototype.sendMessage = function (e) {
            return Promise.reject('PluginMessenger.sendMessage is not implemented for ' + this);
          }),
            (a.PluginMessenger = r),
            (n.prototype = Object.create(r)),
            (n.prototype.constructor = n),
            (n.prototype.sendMessage = function (e) {
              return new Promise(function (r, n) {
                e.isRequest = !0;
                var t = function (e) {
                  if (e && e.source === window && e.data && !e.data.isRequest) {
                    var n = e.data;
                    if (/^webpack.*/g.test(n.type || '')) return;
                    (window.removeEventListener('message', t), r(n));
                  }
                };
                (window.addEventListener('message', t), window.postMessage(e, '*'));
              });
            }),
            (a.NativeMessagingHostMessenger = n),
            (t.prototype = Object.create(r)),
            (t.prototype.constructor = t),
            (t.prototype.sendMessage = function (e) {
              var r = this;
              return new Promise(function (n, t) {
                e.isRequest = !0;
                var i = JSON.stringify(e),
                  o = function (e) {
                    var r = JSON.parse(e);
                    /^webpack.*/g.test(r.type || '') || n(r);
                  };
                try {
                  var s = r.npapiElement().ProcessJSONRequest(i, o);
                  null != s && '' != s && o(s);
                } catch (e) {
                  t(
                    e instanceof TypeError
                      ? new a.PluginError(a.Errors.PLUGIN_NOT_ALLOWED_TO_RUN)
                      : new a.PluginError(a.Errors.UNSPECIFIED_ERROR, { e: e }),
                  );
                }
              });
            }),
            (t.prototype.npapiElement = function () {
              var r = window.document.getElementById('ConnectiveSignerNPAPIPlugin');
              return (
                null == r &&
                  ((r = document.createElement('embed')).setAttribute(
                    'type',
                    'application/x-connectivesignerplugin',
                  ),
                  r.setAttribute('width', 0),
                  r.setAttribute('height', 0),
                  r.setAttribute('id', 'ConnectiveSignerNPAPIPlugin'),
                  e.document.body.appendChild(r)),
                r
              );
            }),
            (a.NPAPIMessenger = t),
            (i.prototype = Object.create(i)),
            (i.prototype.constructor = i),
            (i.prototype.activeXElement = function () {
              var r = e.document.getElementById('ConnectiveSignerIEPlugin');
              return (
                null == r &&
                  ((r = e.document.createElement('object')).setAttribute(
                    'id',
                    'ConnectiveSignerIEPlugin',
                  ),
                  r.setAttribute('classid', 'CLSID:73458F1A-A15D-406F-848C-C8ADA9FE592D'),
                  (r.innerHTML += '<param name="_Version" value="65536">'),
                  (r.innerHTML += '<param name="_ExtentX" value="2117">'),
                  (r.innerHTML += '<param name="_ExtentY" value="1058">'),
                  (r.innerHTML += '<param name="_StockProps" value="0">'),
                  r.setAttribute('style', 'display: none'),
                  e.document.body.appendChild(r)),
                r
              );
            }),
            (i.prototype.sendMessage = function (e) {
              var r = this;
              return new Promise(function (n, t) {
                e.isRequest = !0;
                var i = JSON.stringify(e),
                  o = function (e) {
                    var r = JSON.parse(e);
                    /^webpack.*/g.test(r.type || '') || setTimeout(n(r));
                  };
                try {
                  r.activeXElement().ProcessJSONRequest(i, o);
                } catch (e) {
                  try {
                    var s = r.activeXElement().ProcessJSONRequest(i);
                    null != s && '' != s && o(s);
                  } catch (e) {
                    t(new a.PluginError(a.Errors.PLUGIN_NOT_INSTALLED, { e: e }));
                  }
                }
              });
            }),
            (a.ActiveXMessenger = i));
        })(window),
        (function (e) {
          'use strict';
          function r() {}
          function n() {
            this.currentRequest = void 0;
          }
          function t(e) {
            console.log(e);
            var r = new a.IOSErrorProvider();
            if (o.bridge.hasPendingRequest())
              try {
                var n = null;
                try {
                  n = JSON.parse(e);
                } catch (r) {
                  n = e;
                }
                o.bridge.currentRequest.onError(r.getErrorForResponse(n));
              } finally {
                o.bridge.clearPendingRequest();
              }
            else
              (console.warn('received error but no currentRequest object exists (ignore)', e),
                o.bridge.clearPendingRequest());
          }
          var i = (e.connective = e.connective || {}),
            o = (i.iOSSDK = i.iOSSDK || {}),
            a = (i.plugin = i.plugin || {});
          ((n.prototype.constructor = n),
            (n.prototype.appBeingSuspended = function () {
              (console.log('app is being suspended'),
                this.currentRequest && t({ code: '-9999', message: 'app was suspended' }));
            }),
            (n.prototype.getReaders = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'getReaders',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.getSignerPads = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'getSignerPads',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.connectWithReader = function (e, r, n) {
              this.initializeRequest(r, n);
              var t = {
                function: 'connectWithReader',
                device: JSON.stringify(e),
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              };
              window.webkit.messageHandlers.native.postMessage(t);
            }),
            (n.prototype.readFile = function (e, r, n) {
              this.initializeRequest(r, n);
              var t = {
                function: 'readFile',
                fileCommandValue: e.match(/.{2}/g).join(':').toLowerCase(),
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              };
              window.webkit.messageHandlers.native.postMessage(t);
            }),
            (n.prototype.readSignerCertificate = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readSignerCertificate',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.readRootCertificate = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readRootCertificate',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.readCaCertificate = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readCaCertificate',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.readAuthenticationCertificate = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readAuthenticationCertificate',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.readPhoto = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readPhoto',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.readPersonalInfo = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readPersonalInfo',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.readAddress = function (e, r) {
              this.initializeRequest(e, r);
              window.webkit.messageHandlers.native.postMessage({
                function: 'readAddress',
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              });
            }),
            (n.prototype.computeSignature = function (e, r, n) {
              this.initializeRequest(r, n);
              var t = {
                function: 'computeSignature',
                hash: i.parseUtils.hexStrToBase64(e),
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              };
              window.webkit.messageHandlers.native.postMessage(t);
            }),
            (n.prototype.computeAuthentication = function (e, r, n) {
              this.initializeRequest(r, n);
              var t = {
                function: 'computeAuthentication',
                hash: i.parseUtils.hexStrToBase64(e),
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              };
              window.webkit.messageHandlers.native.postMessage(t);
            }),
            (n.prototype.computeSignatureImage = function (e, r, n, t, o) {
              this.initializeRequest(t, o);
              var a =
                (i.parseUtils.hexStrToBase64(e),
                {
                  function: 'computeSignatureImage',
                  hash: e,
                  signer: r,
                  reason: n,
                  successCallback: 'connective.iOSSDK.successHandler',
                  errorCallback: 'connective.iOSSDK.errorHandler',
                });
              window.webkit.messageHandlers.native.postMessage(a);
            }),
            (n.prototype.openBrowser = function (e, r, n) {
              this.initializeRequest(r, n);
              var t = {
                function: 'openBrowser',
                url: e,
                successCallback: 'connective.iOSSDK.successHandler',
                errorCallback: 'connective.iOSSDK.errorHandler',
              };
              window.webkit.messageHandlers.native.postMessage(t);
            }),
            (n.prototype.initializeRequest = function (e, n) {
              if (this.currentRequest) throw 'Already executing a request...';
              this.currentRequest = { onSuccess: e || r, onError: n || r };
            }),
            (n.prototype.hasPendingRequest = function () {
              return null != this.currentRequest;
            }),
            (n.prototype.clearPendingRequest = function () {
              this.currentRequest = void 0;
            }),
            (o.bridge = new n()),
            (o.successHandler = function (e) {
              if (o.bridge.hasPendingRequest())
                try {
                  var r = null;
                  try {
                    r = JSON.parse(e);
                  } catch (n) {
                    r = e;
                  }
                  o.bridge.currentRequest.onSuccess(r);
                } finally {
                  o.bridge.clearPendingRequest();
                }
              else
                (console.warn('received response but no currentRequest object exists (ignore)', e),
                  o.bridge.clearPendingRequest());
            }),
            (o.errorHandler = t),
            (o.log = function (e) {
              console.log(e);
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            t.BaseErrorProvider.call(this);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (t.Errors = t.Errors || {}),
            o = t.PluginError,
            a = {
              BLUETOOTH_DISABLED: '-5100',
              DEVICE_DISCONNECTED: '-5104',
              VASCO_SDK_LOCKED: '-5106',
              ERROR_CARD_READER_INVALID: '-5108',
              ERROR_CARD_READER_NOT_FOUND: '-5138',
              UNKNOWN_READER: '-5139',
              PAIRING_ERROR: '-5140',
              DEVICE_NOT_DETECTED: '-5141',
              READER_BATTERY_LEVEL_LOW: '-5142',
              MISSING_BLE_SRV_OR_CHARAC: '-5143',
              LOCATION_DISABLED: '-5193',
              PERMISSION_DENIED: '-5194',
              PERMISSION_MISSING: '-5195',
              INTERNAL_ERROR: '-5199',
              DEVICE_INIT_FAILED: '-7000',
              FILE_DOWNLOAD_FAILED: '-7001',
              PINCODE_BLOCKED: '6983',
              PINCODE_WRONG: '63C',
              INVALID_BASE64_HASH: '-8001',
              CANCEL_OR_TIMEOUT: '6401',
              SUSPENDED: '-9999',
              WACOM_SIGNATURE_FAILED_OR_CANCELED: '-8999',
              WACOM_SIGNATURE_NO_SIGNER_OR_REASON: '-8998',
              ERROR_UNSPECIFIED_ERROR: 99,
            };
          ((r.prototype = Object.create(t.BaseErrorProvider.prototype)),
            (r.prototype.constructor = r),
            (r.PLUGIN_ERRORS = a),
            (t.IOSErrorProvider = r),
            (r.prototype.getErrorForResponse = function (e) {
              if ('63C' === e.code.substr(0, 3)) {
                var r = e.code.substr(e.code.length - 1);
                e.code = e.code.substr(0, 3);
              }
              switch (e.code) {
                case a.ERROR_CARD_READER_NOT_FOUND:
                  return new o(i.COULD_NOT_FIND_CARD_READER, { e: e });
                case a.ERROR_CARD_READER_INVALID:
                  return new o(i.BLUETOOTH_TRANSMISSION_FAILED, { e: e });
                case a.READER_BATTERY_LEVEL_LOW:
                  return new o(i.NO_VALID_CARD_PRESENT, { e: e });
                case a.PINCODE_WRONG:
                  return 0 != r && parseInt(r)
                    ? new o(i.INVALID_PIN, { e: e, remainingAttempts: r })
                    : new o(i.LOCKED_CARD, { e: e });
                case a.CANCEL_OR_TIMEOUT:
                  return new o(i.PIN_ENTRY_CANCEL_OR_TIMEOUT, { e: e });
                case a.PINCODE_BLOCKED:
                  return new o(i.LOCKED_CARD, { e: e });
                case a.INVALID_BASE64_HASH:
                  return new o(i.COMPUTE_AUTHENTICATION_FAILED, { e: e });
                case a.BLUETOOTH_DISABLED:
                case a.LOCATION_DISABLED:
                  return new o(i.BLUETOOTH_OR_LOCATIONS_DISABLED, { e: e });
                case a.MISSING_BLE_SRV_OR_CHARAC:
                case a.PAIRING_ERROR:
                  return new o(i.BLUETOOTH_PAIRING_ERROR, { e: e });
                case a.DEVICE_DISCONNECTED:
                  return new o(i.LOST_READER_CONNECTION, { e: e });
                case a.SUSPENDED:
                  return new o(i.APP_GOT_SUSPENDED, { e: e });
                case a.VASCO_SDK_LOCKED:
                  return new o(i.APP_IS_DEAD, { e: e });
                default:
                  return new o(i.UNSPECIFIED_ERROR, { e: e });
              }
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            i.call(this);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = t.BasePluginApi,
            o = /connective-app-ios/;
          ((r.prototype = Object.create(t.BasePluginApi.prototype)),
            (r.prototype.constructor = r),
            (t.IOSPluginApi = r),
            (r.prototype.initialize = function () {
              return Promise.resolve();
            }),
            (r.prototype.checkIfPluginIsInstalled = function () {
              var e = navigator.userAgent;
              return o.test(e)
                ? Promise.resolve()
                : Promise.reject(new t.PluginError(t.Errors.PLUGIN_NOT_INSTALLED));
            }),
            (r.prototype.activate = function (e) {
              return Promise.resolve();
            }),
            (r.prototype.getReaders = function (e) {
              return (
                console.log('polling...'),
                new Promise(function (e, r) {
                  n.iOSSDK.bridge.getReaders(
                    function (n) {
                      var i = [];
                      (n.forEach(function (e) {
                        i.push(new t.IOSReaderHandle(e, 'eid'));
                      }),
                        i && i.length > 0
                          ? e(i)
                          : r(new t.PluginError(t.Errors.NO_CARD_READERS_FOUND)));
                    },
                    function (e) {
                      r(e);
                    },
                  );
                })
              );
            }),
            (r.prototype.getFirstAvailableReader = function () {
              return this.getReaders().then(function (e) {
                if (e.length > 0) return e[0];
                throw new Error('error');
              });
            }),
            (r.prototype.getSignerPads = function () {
              return (
                console.log('polling for signing pads...'),
                new Promise(function (e, r) {
                  n.iOSSDK.bridge.getSignerPads(
                    function (r) {
                      var n = [];
                      (r.forEach(function (e) {
                        n.push(new t.IOSSignerPadHandle(e));
                      }),
                        e(n));
                    },
                    function (e) {
                      r(e);
                    },
                  );
                })
              );
            }),
            (r.prototype.isPollingForReaders = function () {
              return this.pollingForReaders;
            }),
            (r.prototype.pollForReader = function (r, n) {
              var i = this,
                o = 0;
              return (
                (r = r || i.readerPollingDelay),
                (n = n || 0),
                new Promise(function (a, s) {
                  i.pollingForReader = !0;
                  var c = function () {
                    i.getReaders()
                      .then(function (e) {
                        ((i.pollingForReader = !1), a(e));
                      })
                      .catch(function (a) {
                        return a.code === t.Errors.PLUGIN_NOT_ACTIVATED
                          ? void s(a)
                          : ((o += 1),
                            void (i.shouldStopPollingForReader || (n > 0 && o >= n)
                              ? ((i.pollingForReader = !1),
                                (i.shouldStopPollingForReader = !1),
                                s(new t.PluginError(t.Errors.NO_AVAILABLE_CARD_READER_FOUND)))
                              : e.setTimeout(c, r)));
                      });
                  };
                  c();
                })
              );
            }),
            (r.prototype.stopPollingForReader = function () {
              this.pollingForReaders && (this.shouldStopPollingForReaders = !0);
            }),
            (r.prototype.isPollingForReader = function () {
              return this.pollingForReaders;
            }),
            (r.prototype.pollForReaders = function (r, n) {
              console.log('polling');
              var i = this;
              return (
                (r = r || i.readerPollingDelay),
                (n = n || ['eid']),
                new Promise(function (o, a) {
                  i.pollingForReaders = !0;
                  var s = function () {
                    i.getReaders(n)
                      .then(function (e) {
                        if (0 === e.length) throw new Error('No reader with cardPresent found.');
                        ((i.pollingForReaders = !1), o(e));
                      })
                      .catch(function (n) {
                        return (
                          console.log('polling for readers failed with error', n),
                          n.code === t.Errors.PLUGIN_NOT_ACTIVATED ||
                          n.code === t.Errors.APP_GOT_SUSPENDED ||
                          n.code === t.Errors.APP_IS_DEAD
                            ? a(n)
                            : void (i.shouldStopPollingForReaders
                                ? ((i.pollingForReaders = !1),
                                  (i.shouldStopPollingForReaders = !1),
                                  a(new t.PluginError(t.Errors.NO_AVAILABLE_CARD_READER_FOUND)))
                                : e.setTimeout(s, r))
                        );
                      });
                  };
                  s();
                })
              );
            }),
            (r.prototype.stopPollingForReaders = function () {
              this.pollingForReaders && (this.shouldStopPollingForReaders = !0);
            }),
            (r.prototype.isInstalledPluginVersionSupported = function (e) {
              return Promise.resolve(!0);
            }),
            (r.prototype.openBrowser = function (e) {
              n.iOSSDK.bridge.openBrowser(
                e || 'https://www.esignatures.eu/#signatair-portal',
                function () {
                  resolve();
                },
                function () {
                  reject();
                },
              );
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e, r, n) {
            o.call(this, e, r, n);
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (n.iOSSDK = n.iOSSDK || {}),
            o = t.BaseReaderHandle;
          ((r.prototype = Object.create(o.prototype)),
            (r.prototype.constructor = r),
            (t.IOSReaderHandle = r),
            (r.prototype.isPinPadReader = function () {
              return Promise.resolve(!0);
            }),
            (r.prototype.connect = function () {
              var e = this;
              return new Promise(function (r, n) {
                i.bridge.connectWithReader(
                  e.name,
                  function (e) {
                    r(e);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.validatePin = function (e, r) {
              return Promise.resolve();
            }),
            (r.prototype.readFile = function (e) {
              return new Promise(function (r, n) {
                i.bridge.readFile(
                  e,
                  function (e) {
                    r(e);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.readCertificates = function () {
              var e = this,
                r = {};
              return e
                .readCaCertificate()
                .then(function (n) {
                  return ((r.caCert = n), e.readSignerCertificate());
                })
                .then(function (n) {
                  return ((r.signerCert = n), e.readRootCertificate());
                })
                .then(function (n) {
                  return ((r.rootCert = n), e.readAuthenticationCertificate());
                })
                .then(function (e) {
                  return ((r.authenticationCert = e), r);
                });
            }),
            (r.prototype.readAuthenticationCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readAuthenticationCertificate(
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readRootCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readRootCertificate(
                  function (n) {
                    return '00' === n.substr(0, 2)
                      ? void r(new t.PluginError(t.Errors.UNABLE_TO_READ_ROOT_CERT))
                      : void e(n);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readCaCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readCaCertificate(
                  function (n) {
                    return '00' === n.substr(0, 2)
                      ? void r(new t.PluginError(t.Errors.UNABLE_TO_READ_CA_CERT))
                      : void e(n);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readSignerCertificate = function () {
              return new Promise(function (e, r) {
                i.bridge.readSignerCertificate(
                  function (n) {
                    return '00' === n.substr(0, 2)
                      ? void r(new t.PluginError(t.Errors.UNABLE_TO_READ_SIGNER_CERT))
                      : void e(n);
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.computeSignature = function (e, r, n) {
              return new Promise(function (e, n) {
                i.bridge.computeSignature(
                  r,
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.computeAuthentication = function (e, r) {
              return new Promise(function (e, n) {
                i.bridge.computeAuthentication(
                  r,
                  function (r) {
                    e(r);
                  },
                  function (e) {
                    n(e);
                  },
                );
              });
            }),
            (r.prototype.readPersonalInformation = function (e) {
              return new Promise(function (e, r) {
                i.bridge.readPersonalInfo(
                  function (i) {
                    try {
                      var o = n.parseUtils.hexStrToByteArray(i),
                        a = new n.PersonalInformationParser();
                      e(a.parse(o));
                    } catch (e) {
                      r(new t.PluginError(t.Errors.UNSPECIFIED_ERROR, { e: e }));
                    }
                  },
                  function (e) {
                    r(e);
                  },
                );
              });
            }),
            (r.prototype.readAddress = function (e) {
              return new Promise(function (e, r) {
                i.bridge.readAddress(
                  function (i) {
                    try {
                      var o = n.parseUtils.hexStrToByteArray(i),
                        a = new n.AddressParser();
                      e(a.parse(o));
                    } catch (e) {
                      r(new t.PluginError(t.Errors.UNSPECIFIED_ERROR, { e: e }));
                    }
                  },
                  function (e) {
                    (console.log(e), r(e));
                  },
                );
              });
            }),
            (r.prototype.readPhoto = function (e) {
              return (
                (e = void 0 === e || e),
                new Promise(function (r, o) {
                  i.bridge.readPhoto(
                    function (i) {
                      try {
                        if (e) {
                          var a = n.parseUtils.hexStrToBase64(i);
                          r(a);
                        } else r(i.data);
                      } catch (e) {
                        o(new t.PluginError(t.Errors.UNSPECIFIED_ERROR, { e: e }));
                      }
                    },
                    function (e) {
                      o(e);
                    },
                  );
                })
              );
            }),
            (r.prototype.isBluetoothReader = function () {
              return !0;
            }),
            (r.prototype.selectMaestro = function () {
              throw 'Unimplemented selectMaestro';
            }),
            (r.prototype.getProcessingOptions = function (e) {
              throw 'Unimplemented getProcessingOptions';
            }),
            (r.prototype.readRecord = function (e, r) {
              throw 'Unimplemented readRecord';
            }),
            (r.prototype.readPrimaryAccountNumber = function () {
              throw 'Unimplemented readPrimaryAccountNumber';
            }),
            (r.prototype.signTransactionNumber = function (e, r, n) {
              throw 'Unimplemented signTransactionNumber';
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e) {}
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = (n.iOSSDK = n.iOSSDK || {});
          ((r.prototype = Object.create(t.BaseSignerPadHandle)),
            (r.prototype.constructor = r),
            (t.IOSSignerPadHandle = r),
            (r.prototype.computeSignatureImage = function (e, r, n) {
              return new Promise(function (t, o) {
                i.bridge.computeSignatureImage(
                  e,
                  r,
                  n,
                  function (e) {
                    t(e);
                  },
                  function (e) {
                    o(e);
                  },
                );
              });
            }));
        })(window),
        (function (e) {
          'use strict';
          function r() {
            (i.call(this), console.log('Mobile browser plugin!!'));
          }
          var n = (e.connective = e.connective || {}),
            t = (n.plugin = n.plugin || {}),
            i = t.BasePluginApi;
          ((r.prototype = Object.create(t.BasePluginApi.prototype)),
            (r.prototype.constructor = r),
            (t.MobileBrowserPluginApi = r),
            (r.prototype.openBrowser = function (e) {
              window.location = e;
            }),
            (r.prototype.initialize = function () {
              return Promise.resolve();
            }),
            (r.prototype.checkIfPluginIsInstalled = function () {
              return Promise.reject(new t.PluginError(t.Errors.PLUGIN_NOT_INSTALLED));
            }));
        })(window),
        (function (e) {
          'use strict';
          var r = (e.connective = e.connective || {}),
            n = ((r.plugin = r.plugin || {}), (r.smartcards = r.smartcards || {}));
          n.beid = n.beid || {};
          n.beid.readerContainsBeIDCard = function (e) {
            if (!e.isCardPresent) return Promise.resolve(!1);
            switch (e.type) {
              case 'beid':
                return Promise.resolve(!0);
              default:
                var r =
                  (e.atr &&
                    e.atr.length > 0 &&
                    0 === e.atr.localeCompare('3B9813400AA503010101AD1311')) ||
                  0 === e.atr.localeCompare('3B9813400AA503010101AD13');
                return (r && (e.type = 'beid'), Promise.resolve(r));
            }
          };
        })(window),
        (function (e) {
          'use strict';
          var r = (e.connective = e.connective || {}),
            n = ((r.plugin = r.plugin || {}), (r.smartcards = r.smartcards || {}));
          ((n.belawyer = n.belawyer || {}),
            (n.belawyer.readerContainsBeLawyerCard = function (e) {
              if (!e.isCardPresent) return Promise.resolve(!1);
              switch (e.type) {
                case 'belawyer':
                  return Promise.resolve(e);
                default:
                  return Promise.resolve()
                    .then(function () {
                      return new n.belawyer.BeLawyerCardHandler(e).readCIAInfoFile();
                    })
                    .then(function (r) {
                      return (
                        -1 !=
                          r.indexOf(
                            '436172644F5320504B4353233135205A657465732F4450412050726F66696C65',
                          ) && ((e.type = 'belawyer'), !0)
                      );
                    })
                    .catch(function () {
                      return !1;
                    });
              }
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e) {
            ((this.readerHandle = e), (this.readerHandle.type = 'belawyer'));
          }
          var n = (e.connetive = e.connective || {}),
            t = (n.encoding = n.encoding || {}),
            i = (n.plugin = n.plugin || {}),
            o = (n.smartcards = n.smartcards || {}),
            a = i.DesktopErrorProvider,
            s = '501543042F01',
            c = '50154304C001',
            u = '50154304503A',
            d = '50154304503B',
            l = '501544444403',
            p = '501544444404',
            g = '50155032';
          ((o.belawyer = o.belawyer || {}),
            (o.belawyer.BeLawyerCardHandler = r),
            (r.prototype.readAuthenticationCertificate = function () {
              return this.readerHandle.readFile(s);
            }),
            (r.prototype.readNonRepudiationCertificate = function () {
              return this.readerHandle.readFile(c).catch(function (e) {
                return e && e.e && e.e.id === a.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE
                  ? Promise.reject(new i.PluginError(i.Errors.UNABLE_TO_READ_SIGNER_CERT))
                  : Promise.reject(e);
              });
            }),
            (r.prototype.readIntermediateCaCertificate = function () {
              return this.readerHandle.readFile(u).catch(function (e) {
                return e && e.e && e.e.id === a.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE
                  ? Promise.reject(new i.PluginError(i.Errors.UNABLE_TO_READ_CA_CERT))
                  : Promise.reject(e);
              });
            }),
            (r.prototype.readRootCaCertificate = function () {
              return this.readerHandle.readFile(d).catch(function (e) {
                return e && e.e && e.e.id === a.PLUGIN_ERRORS.ERROR_FAILED_TO_READ_FILE
                  ? Promise.reject(new i.PluginError(i.Errors.UNABLE_TO_READ_ROOT_CERT))
                  : Promise.reject(response);
              });
            }),
            (r.prototype.readCIAInfoFile = function () {
              return this.readerHandle.readFile(g);
            }),
            (r.prototype.readRawPersonalInformation = function () {
              return this.readerHandle.readFile(l);
            }),
            (r.prototype.readPersonalInformation = function () {
              return this.readRawPersonalInformation().then(function (e) {
                var r = t.tlv.decodeSimpleTLV(t.bytes.decodeHexString(e));
                return {
                  lawyerId: r[1].toString(),
                  name: r[2].toString(),
                  firstName: r[3].toString(),
                  partOfCardNumber: r[5].toString(),
                  expiryDate: r[6].toString(),
                  issuer: r[7].toString(),
                };
              });
            }),
            (r.prototype.readPhoto = function () {
              return this.readerHandle.readFile(p).then(function (e) {
                return n.parseUtils.hexStrToBase64(e);
              });
            }),
            (r.prototype.signAuthentication = function (e, r) {
              return this.readerHandle.computeAuthentication(r, e);
            }),
            (r.prototype.signNonRepudiation = function (e, r, n) {
              return this.readerHandle.computeSignature(r, e, n);
            }));
        })(window),
        (function (e) {
          'use strict';
          var r = (e.connective = e.connective || {}),
            n = ((r.plugin = r.plugin || {}), (r.smartcards = r.smartcards || {}));
          ((n.emv = n.emv || {}),
            (n.emv.readerContainsEmvCard = function (e) {
              if (!e.isCardPresent) return Promise.resolve(!1);
              switch (e.type) {
                case 'emv':
                  return Promise.resolve(!0);
                default:
                  return e
                    .selectMaestro()
                    .then(function () {
                      return ((e.type = 'emv'), !0);
                    })
                    .catch(function () {
                      return !1;
                    });
              }
            }));
        })(window),
        (function (e) {
          'use strict';
          var r = (e.connective = e.connective || {}),
            n = (r.encoding = r.encoding || {}),
            t = (n.bytes = n.bytes || {});
          ((t.decodeHexString = function (e) {
            for (var r = [], n = (e = e.replace(/(\s|0x)/g, '')).length / 2, t = 0; r.length < n; )
              (r.push(parseInt(e[t] + e[t + 1], 16)), (t += 2));
            return r;
          }),
            (t.encodeHexString = function (e) {
              for (var r = '', n = 0, t = e.length; n < t; n++) {
                var i = e[n];
                r += i < 16 ? '0' + i.toString(16) : i.toString(16);
              }
              return r.toUpperCase();
            }),
            (t.decodeBase64 = function (e) {
              for (var r = atob(e), n = [], t = 0, i = r.length; t < i; t++) n[t] = r.charCodeAt(t);
              return n;
            }),
            (t.encodeBase64 = function (e) {
              for (var r = '', n = 0, t = e.length; n < t; n++)
                r += String.fromCharCode.call(null, e[n]);
              return btoa(r);
            }));
        })(window),
        (function (e) {
          'use strict';
          function r(e, r, n) {
            for (var t = [], i = r, o = r + n; i < o; i++) t.push(e[i]);
            return t;
          }
          function n(e, r, n) {
            ((this.tag = e), (this.length = r), (this.data = n));
          }
          var t = (e.connective = e.connective || {}),
            i = (t.encoding = t.encoding || {}),
            o = (i.tlv = i.tlv || {});
          ((o.decodeSimpleTLV = function (e) {
            for (var t = [], i = 0; i < e.length; ) {
              var o = e[i++],
                a = e[i++],
                s = r(e, i, a);
              (t.push(new n(o, a, s)), (i += a));
            }
            return t;
          }),
            o.TLVEntry,
            (n.prototype.toString = function () {
              for (var e, r, n = this.data.slice(), t = '', i = 0; i < n.length; )
                (e = n[i++]) <= 191
                  ? (t += String.fromCharCode(e))
                  : e >= 194 && e < 224
                    ? ((r = ((31 & e) << 6) + (63 & n[i++])), (t += String.fromCharCode(r)))
                    : e >= 224 && e < 240
                      ? ((r = ((15 & e) << 12) + ((63 & n[i++]) << 6) + (63 & n[i++])),
                        (t += String.fromCharCode(r)))
                      : e >= 240 &&
                        e <= 244 &&
                        ((r =
                          ((7 & e) << 18) +
                          ((63 & n[i++]) << 12) +
                          ((63 & n[i++]) << 6) +
                          (63 & n[i++])),
                        (t += String.fromCharCode(r)));
              return t;
            }));
        })(window));
    },
    function (e, r, n) {
      'use strict';
      Object.defineProperty(r, '__esModule', { value: !0 });
      var t = n(0),
        i = n(0),
        o = n(0),
        a = (window.connective = window.connective || {}),
        s = (function () {
          function e(e, r, n) {
            ((this.newApi = e),
              (this.newReader = r),
              (this.newCardHandler = this.newApi.getCardHandler(this.newReader)));
          }
          return (
            (e.prototype.readAuthenticationCertificate = function () {
              return this.newCardHandler
                .readCertificates(this.newReader, t.BeLawyer.CertificateKindHints.Authentication)
                .then(function (e) {
                  return i.Encoding.encodeAsHexString(i.Encoding.decodeBase64String(e[0]));
                });
            }),
            (e.prototype.readNonRepudiationCertificate = function () {
              return this.newCardHandler
                .readCertificates(this.newReader, t.BeLawyer.CertificateKindHints.NonRepudiation)
                .then(function (e) {
                  return i.Encoding.encodeAsHexString(i.Encoding.decodeBase64String(e[0]));
                });
            }),
            (e.prototype.readIntermediateCaCertificate = function () {
              return this.newCardHandler
                .readCertificates(this.newReader, t.BeLawyer.CertificateKindHints.IntermediateCa)
                .then(function (e) {
                  return i.Encoding.encodeAsHexString(i.Encoding.decodeBase64String(e[0]));
                });
            }),
            (e.prototype.readRootCaCertificate = function () {
              return this.newCardHandler
                .readCertificates(this.newReader, t.BeLawyer.CertificateKindHints.RootCa)
                .then(function (e) {
                  return i.Encoding.encodeAsHexString(i.Encoding.decodeBase64String(e[0]));
                });
            }),
            (e.prototype.readCIAInfoFile = function () {
              return Promise.reject(new o.Exceptions.FeatureNotSupportedException());
            }),
            (e.prototype.readRawPersonalInformation = function () {
              return Promise.reject(new o.Exceptions.FeatureNotSupportedException());
            }),
            (e.prototype.readPersonalInformation = function () {
              return Promise.reject(new o.Exceptions.FeatureNotSupportedException());
            }),
            (e.prototype.readPhoto = function () {
              return this.newCardHandler
                .readData(this.newReader, t.BeLawyer.DataKindHints.Photo)
                .then(function (e) {
                  return e[t.BeLawyer.DataKindHints.Photo];
                });
            }),
            (e.prototype.signAuthentication = function (e, r) {
              return this.newCardHandler
                .computeSignature(
                  this.newReader,
                  t.BeLawyer.SignatureKindHints.Authentication,
                  i.Encoding.decodeHexString(e),
                  this.legacyReader.lastPinToken,
                )
                .then(function (e) {
                  return i.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return e instanceof o.Exceptions.InvalidPinException
                    ? 0 === e.remainingTries || e.pinBlocked
                      ? Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.LOCKED_CARD, {
                            remainingAttempts: 0,
                          }),
                        )
                      : Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.INVALID_PIN, {
                            remainingAttempts: e.remainingTries,
                          }),
                        )
                    : e instanceof o.Exceptions.OperationCanceledException
                      ? Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.PIN_ENTRY_CANCEL_OR_TIMEOUT, {
                            e: e,
                          }),
                        )
                      : Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                        );
                });
            }),
            (e.prototype.signNonRepudiation = function (e, r, n) {
              return this.newCardHandler
                .computeSignature(
                  this.newReader,
                  t.BeLawyer.SignatureKindHints.NonRepudiation,
                  i.Encoding.decodeHexString(e),
                  this.legacyReader.lastPinToken,
                )
                .then(function (e) {
                  return i.Encoding.encodeAsHexString(e);
                })
                .catch(function (e) {
                  return e instanceof o.Exceptions.InvalidPinException
                    ? 0 === e.remainingTries || e.pinBlocked
                      ? Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.LOCKED_CARD, {
                            remainingAttempts: 0,
                          }),
                        )
                      : Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.INVALID_PIN, {
                            remainingAttempts: e.remainingTries,
                          }),
                        )
                    : e instanceof o.Exceptions.OperationCanceledException
                      ? Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.PIN_ENTRY_CANCEL_OR_TIMEOUT, {
                            e: e,
                          }),
                        )
                      : Promise.reject(
                          new a.plugin.PluginError(a.plugin.Errors.UNSPECIFIED_ERROR, { e: e }),
                        );
                });
            }),
            e
          );
        })();
      r.BeLawyerCardHandleInterop = s;
    },
    function (e, r, n) {
      'use strict';
      Object.defineProperty(r, '__esModule', { value: !0 });
      var t = n(0),
        i = (function () {
          function e(e, r) {
            ((this.newSingerPad = e), (this.newApi = r));
          }
          return (
            (e.prototype.computeSignatureImage = function (e, r, n) {
              return this.newApi
                .getSignerPadHandler(this.newSingerPad)
                .computeSignature(this.newSingerPad, t.Encoding.decodeHexString(e), n, r);
            }),
            e
          );
        })();
      r.SignerPadInterop = i;
    },
    function (e, r, n) {
      'use strict';
      (Object.defineProperty(r, '__esModule', { value: !0 }),
        (function (e) {
          ((e.eID = 'eid'), (e.BeID = 'beid'), (e.EMV = 'emv'), (e.BeLawyer = 'belawyer'));
        })(r.LegacyCardType || (r.LegacyCardType = {})));
    },
    function (e, r, n) {
      'use strict';
      Object.defineProperty(r, '__esModule', { value: !0 });
      var t = n(0),
        i = n(1),
        o = (window.connective = window.connective || {}),
        a = (function () {
          function e(e) {
            switch (t.PlatformUtils.getPlatform()) {
              case t.Platform.Desktop:
                this.targetPluginApiInstace = new i.PluginApiInterop(e);
                break;
              case t.Platform.AndroidApp:
                this.targetPluginApiInstace = new o.plugin.AndroidPluginApi();
                break;
              case t.Platform.IOSApp:
                this.targetPluginApiInstace = new o.plugin.IOSPluginApi();
                break;
              case t.Platform.MobileBrowser:
                this.targetPluginApiInstace = new o.plugin.MobileBrowserPluginApi();
            }
          }
          return (
            (e.prototype.initialize = function () {
              return this.targetPluginApiInstace.initialize();
            }),
            (e.prototype.checkIfPluginIsInstalled = function () {
              return this.targetPluginApiInstace.checkIfPluginIsInstalled();
            }),
            (e.prototype.activate = function (e) {
              return this.targetPluginApiInstace.activate(e);
            }),
            (e.prototype.getReaders = function (e) {
              return this.targetPluginApiInstace.getReaders(e);
            }),
            (e.prototype.getFirstAvailableReader = function () {
              return this.targetPluginApiInstace.getFirstAvailableReader();
            }),
            (e.prototype.getSignerPads = function () {
              return this.targetPluginApiInstace.getSignerPads();
            }),
            (e.prototype.isPollingForReaders = function () {
              return this.targetPluginApiInstace.isPollingForReaders();
            }),
            (e.prototype.pollForReader = function (e, r) {
              return (
                void 0 === e && (e = 1e3),
                void 0 === r && (r = 0),
                this.targetPluginApiInstace.pollForReader(e, r)
              );
            }),
            (e.prototype.stopPollingForReader = function () {
              return this.targetPluginApiInstace.stopPollingForReader();
            }),
            (e.prototype.isPollingForReader = function () {
              return this.targetPluginApiInstace.isPollingForReader();
            }),
            (e.prototype.pollForReaders = function (e, r) {
              return (
                void 0 === e && (e = 1e3),
                void 0 === r && (r = []),
                this.targetPluginApiInstace.pollForReaders(e, r)
              );
            }),
            (e.prototype.stopPollingForReaders = function () {
              return this.targetPluginApiInstace.stopPollingForReaders();
            }),
            (e.prototype.isInstalledPluginVersionSupported = function (e) {
              return this.targetPluginApiInstace.isInstalledPluginVersionSupported(e);
            }),
            (e.prototype.openBrowser = function (e) {
              return this.targetPluginApiInstace.openBrowser(e);
            }),
            e
          );
        })();
      ((r.AutoPluginApi = a), (o.ConnectivePluginApi = a));
    },
  ]);
});
